export default {
  shopMng: {
    myShop: 'My Shop', //我的店铺
    productPubsub: 'Release commodity', //商品发布
    taskPubsub: 'Release task', //任务发布
    orderMng: 'Order management', //订单管理
    myAddress: 'Warehouse management' //仓库管理
  },
  //  我的店铺
  myShop: {
    serialNumber: 'Serial number', //序号
    shopName: 'Shop name', //店铺名称
    shopType: 'Shop type', //店铺类型
    shopLogo: 'Shop logo', //店铺Logo
    shopStart: 'Opening hours', //开店时间
    shopStatus: 'Business status', //营业状态
    usual: 'Regular business', //正常营业
    prohibit: 'Ban', //违规禁封
    operate: 'Operation', //操作
    inputShopNamePlaceholder: 'Enter shop name', //输入店铺名称
    selectStatusPlaceholder: 'Please select business status', //请选择营业状态
    search: 'Search', //查询
    clear: 'Clear', //重置
    shopInfo: 'Store profile', //店铺简介
    infoChange: 'Information change', //信息变更
    shopMainPic: 'Shop banner', //店铺banner
    brandSelfStore: 'Brand self-operated store', //品牌自营店铺

    //  店铺简介
    tel: 'Phone number', //手机号
    people: 'Contact person', //联系人
    address: 'Address', //联系地址
    businessLicense: 'Business license', //营业执照
    tax: 'Tax No.' //税号
  },
  //  商品发布
  productPubsub: {
    addProduct: 'Add commodity', //添加商品
    picProduct: 'Commodity picture', //商品图片
    namePro: 'Commodity name', //商品名称
    saleNum: 'Sales volume', //销量
    tyep: 'Category', //所属分类
    status: 'Audit status', //审核状态
    setStatus: 'Set status', //设置状态
    operate: 'Operation', //操作
    editPro: 'Commodity editing', //商品编辑
    viewSpecs: 'Specifications check', //查看规格
    repPro: 'Replenishment', //商品补货
    notificationPro: 'Notice', //商品通知
    putOn: 'On plantform', //上架
    videoPro: 'Video', //商品视频
    top: 'Pin', //置顶
    giveaway: 'Gift', //赠品
    statusUsual: 'Pass', //审核通过
    noAuth: 'Unaudited', //待审核

    //添加商品
    proBrand: 'Commodity brand', //商品品牌
    typeInput: 'Classification entrance', //分类入口
    typePro: 'Commodity classification', //商品分类
    ProductType: 'Product type', // 商品类型 1.5.12 新增
    virtuallyProductType: 'Virtual product type', // 虚拟商品类型
    ordinaryCommodity: 'general merchandise', // 普通商品 1.5.12 新增
    PackageCommodity: 'Package products', // 套餐商品 1.5.12 新增
    virtuallyCommodity: 'virtual goods', // 虚拟商品 1.5.12 新增
    admissionFee: 'admission fee', // 门票
    electronicRoll: 'Electronic coupons', // 电子劵
    site: 'site', // 场地 1.5.12 新增
    namePro: 'Commodity name', //商品名称
    proSecondTitle: 'Commodity subtitle', //商品副标题
    proInfo: 'Commodity introduction', //商品介绍
    computerUnit: 'Unit of measurement', //计量单位
    proKey: 'Commodity keyword', //商品关键字
    nextStep: 'Next ', //下一步
    lastStep: 'Back', //上一步
    specificationTemplate: 'Specification template', //规格模板
    add: 'Add', //增加
    clickToUpload: 'Upload', //点击上传
    productParameters: 'Commodity parameters', //商品参数
    refreshTheList: 'Refresh', //刷新列表
    salesInformation: 'Sales message', //销售信息
    internationalBarcode: 'International barcode', //国际条码
    skuCode: 'SKU codingSKU', //编码
    supplyPrice: 'Supply price', //供货价
    suggestedPrice: 'Suggested selling price', //建议售价
    proStock: 'Commodity stock', //商品库存
    inventoryWarningValue: 'Inventory warning value', //库存预警值
    long: 'Long（cm）', //
    width: 'Width（cm）', //
    height: 'Height（cm）', //
    grossWeight: 'Weight（kg）', //
    productCode: 'Commodity code', //商品编码
    proMainPic: 'Commodity main pictures', //商品主图
    proDetail: 'Details', //商品详情
    uploadPic: 'Upload pictures', //上传图片
    basePolicy: 'Basic policy', //基本政策
    fakeOnePayThree: 'Any fake product will be paid at 3 times of the genuine product', //假一赔三
    brandAfter: 'Brand after-sales', //品牌售后
    fastDelivery: 'Quick delivery', //快速发货
    fastRefund: 'Quick refund', //快速退款
    chosePolicy: 'Optional Policy', //可选政策
    proFreeShipping: 'Free delivery', //商品包邮
    selectShippingWarehouse: 'Select delivery from warehouse', //选择发货仓库
    deliveryAddress: 'Shipping address', //发货地址
    submitProduct: 'Done, submit the product', //完成，提交商品
    address: 'address', // 地址
    longitudeAndLatitudePrompts: 'Please enter longitude and latitude' // 请输入经纬度
  },
  //  任务发布
  taskPubsub: {
    searchCondition: 'Filter search', //筛选搜索
    taskType: 'Task type', //任务类型
    search: 'Search', //查询
    clear: 'Clear', //重置
    dataList: 'Data list', //数据列表
    add: 'Add', //添加
    serialNumber: 'Serial number', //序号
    picProduct: 'Commodity picture', //商品图片
    namePro: 'Commodity name', //商品名称
    start: 'Start', //开始时间
    end: 'End', //结束时间
    operate: 'Operation', //操作
    viewDetail: 'Details viewing', //查看详情

    //添加任务
    chosePro: 'Select commodity', //选择商品
    growthTool: 'Growth tool', //增长工具
    skuPic: 'SKU pictureSKU', //图片
    skuPara: 'SKU parameterSKU', //参数
    priceAdjust: 'Readjust prices', //调价
    giveawayStock: 'Gift stock', //赠品库存
    startTime: 'Start', //开始日期
    endTime: 'End', //结束日期
    chooseAProduct: 'Select commodity with multiple specifications', //选择商品，可选择多规格
    searchSKU: 'Research SKU', //查询SKU
    pic: 'Picture', //图片
    param: 'Parameters', //参数
    salePrice: 'Sale price', //销售价格
    proStock: 'Commodity stock', //商品库存
    taskStock: 'Task stock', //任务库存
    giveawayChose: 'Choose Gift' //选择赠品
  },
  //  订单管理
  orderMng: {
    searchCondition: 'Filter search', //筛选搜索
    searchInput: 'Input and search', //输入搜索
    receiver: 'Receiver', //收货人
    submissionTime: 'Submission time', //提交时间
    orderStatus: 'Order status', //订单状态
    orderType: 'Order type', //订单分类
    orderSource: 'Order source', //订单来源
    search: 'Search', //查询
    clear: 'Clear', //重置
    dataList: 'Data list', //数据列表
    num: 'Serial number', //序号
    orderNum: 'Order No.', //订单编号
    putTime: 'Submission time', //提交时间
    userNum: 'User account', //用户账号
    orderMoney: 'Order amount', //订单金额
    payType: 'Mode of payment', //支付方式
    orderSource: 'Order source', //订单来源
    orderStatus: 'Order status', //订单状态
    operate: 'Operation', //操作
    reviewOrder: 'View ', //查看订单

    //查看订单
    putOrder: 'Submit order', //提交订单
    userPay: 'User payment', //用户付款
    shopShip: 'Shop delivery', //店铺发货
    fastDelivery: 'Fast delivery', //快速配送
    UserReceivesGoods: 'User receiving', //用户收货
    quickServece: 'Fast service', //快速服务
    orderTime: 'Order time', //订单已耗时
    shopStockUp: 'Store is stocking', //店铺备货中
    shipDetail: 'Delivery details', //快递详情
    quickPro: 'Immediate delivery', //立即发货
    prsentStatus: 'Present order status', //当前订单状态
    editOwerInfo: 'Edit receiver information', //修改收货人信息
    sendMessage: 'Send internal message', //发送站内信
    cancelOrder: 'Cancel order', //取消订单
    remarkOrder: 'Remarks order', //备注订单
    orderInfo: 'Order information', //订单信息
    orderSku: 'Order number', //订单编号
    placeAnOrder: 'Order time', //下单时间
    UserID: 'User ID', //用户ID
    payType: 'Mode of payment', //支付方式
    orderSource: 'Order source', //订单来源
    proPic: 'Commodity picture', //商品图片
    productName: 'Commodity name', //商品名称
    supplyPrice_: 'Supply price', ///供货价/件
    Specification: 'Specifications', //规格
    num: 'Number', //数量
    shopDiscount: 'Store discount', //店铺优惠
    Subtotal: 'Subtotal', //小计
    logisticsInformation: 'Logistic information', //物流信息
    deliveryMethod: 'Delivery method', //配送方式
    shipmentNumber: 'Logistics No.', //物流单号
    sumitTime: 'Automatically confirm receipt time', //自动确认收货时间
    orderAvailable: 'Coins from order', //订单可得优币
    orderAvailableValue: 'Growth value from order', //订单可得成长值
    activeInfo: 'Activity information', //活动信息
    payInfo: 'Payment information', //支付信息
    payType: 'Mode of payment', //支付方式
    payTime: 'Payment time', //支付时间
    supplyPrice: 'Supply price', //供货价
    freight: 'Freight', //运费
    discount: 'Discount', //优惠
    installmentServiceFee: 'Installment service fee', //分期服务费
    tax: 'VAT taxVAT', //税费
    integral: 'Integral', //积分
    totalPayment: 'Total payment', //合计支付
    operatInformation: 'Operation information', //操作信息
    num: 'Serial number', //序号
    operater: 'Operator', //操作者
    orderStatus: 'Order status', //订单状态
    operatHistory: 'Operation record', //操作记录
    operateTime: 'Operation time', //操作时间
    remark: 'Remark' //备注
  },
  //  仓库管理
  myAddress: {
    addNewAddress: 'Adding warehouse for delivery', //新增发货仓库
    num: 'Serial number', //序号
    addressName: 'Warehouse name', //仓库名称
    address: 'Warehouse address', //仓库地址
    manager: 'Manager', //管理人
    tel: 'Phone number', //联系电话
    operate: 'Operation', //操作
    updateAddress: 'Change warehouse address', //变更仓库地址

    //添加仓库
    addAgainIfMore: 'If there are multiple warehouses, please add the address again.', //品牌若存在多个仓库请重新添加
    whickPlace: 'Area', //所在地区
    detailAddress: 'Detailed address', //详细地址
    postCode: 'Post code', //邮编
    usualLogis: 'Configure common logistics', //配置常用物流
    defaultLogis: 'Default logistics' //默认物流
  },
  //  开通店铺
  openShop: {
    myBrand: 'My Brand', //我的品牌
    openSelfShop: 'Start brand self-management', //开启品牌自营店铺
    num: 'Serial number', //序号
    brandName: 'Brand name (ID)', //品牌名称（ID）
    brandName1: 'Brand name', //品牌名称（ID）
    brandLogo: "Brand's Logo", //品牌商标
    operateCountry: 'Country of operation', //运营国家
    operateType: 'Operation type', //运营类型
    brandStatus: 'Brand status', //品牌状态
    operate: 'Operation', //操作
    brandInfo: 'Brand introduction', //品牌简介
    inputPlaceBrand: 'Enter the brand name', //输入品牌名称
    waitAuth: 'Unaudited', //待审核
    usual: 'Normal', //正常
    shopLogoNum: 'Trademark registration number', //,商标注册号
    brandFromCountry: 'Brand attribution', //品牌归属地
    ownerBrand: 'Brand owner', //品牌所有人
    tel: 'Phone number', //联系手机
    email: 'E-mail', //联系邮箱
    email1: 'E-mail', //联系邮箱
    evidence: 'Proof material' //证明材料
  },
  //  资产中心
  assetCenter: {
    REType: 'Revenue and expenditure type', //收支类型
    TranCompTime: 'Transaction completion time', //交易完成时间
    num: 'Serial number', //序号
    orderNum: 'Order number', //订单号
    waterNum: 'Serial number', //流水号
    TrWdAmount: 'Transaction/withdrawal amount', //交易/提现金额
    deductHandFee: 'Total amount after deducting the handling fee', //扣除手续费总额
    actualDepositDisbursementAmount: 'Amount actually recorded/posted', //实际入账/出账金额
    totalAmount: 'Total account', //当前账户总金额

    WithdrawalApplicateTime: 'Time for withdrawal application', //提现申请时间
    WithdrawalNum: 'Cash withdrawal number', //提现单号
    amountWithdrawn: 'Withdrawable amount', //可提现金额
    applicationWithdrawalAmount: 'Application for withdrawal amount', //申请提现金额
    WithdrawalFee: 'Withdrawal fee', //提现手续费
    actualAmountReceived: 'Actual amount received', //实际到账金额
    IDPassportExpirationDate: 'ID card/passport validity period', //身份证/护照有效期
    CardholderName: 'Cardholder name', //持卡人姓名
    BankDeposit: 'Bank deposit', //开户银行
    BankCardNumber: 'Bank card number', //银行卡卡号
    BankCardValidityPeriod: 'Bank card validity period', //银行卡有效期
    applicant: 'Applicant', //申请人
    withdrawalStatus: 'Withdrawal status', //提现状态
    actualPaymentAmount: 'Actual payment amount', //实际打款金额
    auditOperators: 'Audit operators', //审核操作人员
    processingCompletionTime: 'Processing completion time', //处理完成时间
    operate: 'Operation', //操作

    //  新加   6-30
    withdraw: 'Withdrawal', //提现
    WithdrawableBalance: 'Withdrawable balance', //可提现余额
    frozenAmount: 'Frozen amount', //冻结金额
    bindBankCard: 'Bind Bank Card', //绑定银行卡
    revenueExpenditureRecords: 'Income and expenditure record', //收支记录
    revenueExpenditureType: 'Payment type', //收支类型
    applicationTime: 'Application time', //申请时间
    paymentTime: 'Payment time', //付款时间
    orderType: 'Order type', //订单类型
    orderCompletionTime: 'Order completion time', //订单完成时间
    parentOrderNumber: 'Parent order number', //母订单编号
    subOrderNumber: 'Sub order number', //子订单编号
    afterSalesStatus: 'After sales status', //售后状态
    afterSalesApplicationTime: 'After sales request time', //售后申请时间
    afterSalesOrderNumber: 'After sales order number' //售后单编号
  },
  //  活动管理
  activeMng: {
    filterSearch: 'Filter search', //筛选搜索
    inputSearch: 'Input and search', //输入搜索
    clear: 'Clear', //重置
    search: 'Search', //查询
    activeName: 'Activity name', //活动名称
    activeStart: 'Activity start time', //活动开始日期
    founder: 'Founder', //创建人
    activeCreate: 'Activity creation time ', //活动创建时间
    activeStatus: 'Activity Status', //活动状态
    authStatus: 'Audit status', //审核状态
    activeSecondTitle: 'Activity subtitle', //活动副标题
    listPic: 'List diagram', //列表图
    detailPic: 'Detail page', //详情图
    taskPro: 'Task commodity', //任务商品
    levelAward: 'Level reward', //关卡奖励
    activeSecondTitle: 'Add commodity from activity task', //添加活动任务商品
    choseLevelAward: 'Choose level gifts', //选择关卡赠品
    choseNumAward: 'Choose ranking reward', //选择排名奖励
    endNum: 'End ranking', //结束名次
    startNum: 'Start ranking' //开始名次
  },
  //  活动审核
  activeAuth: {
    activeList: 'Activity list', //活动列表
    startTime: 'Activity start time', //开始日期
    endTime: 'Activity end time', //结算日期
    validityPeriod: 'Activity validity period', //活动有效期
    activeName: 'Activity name', //活动名称
    operateTime: 'Operation time', //操作时间
    productStock: 'Available inventory of good', //商品可用库存
    activeTaskStock: 'Inventory of activity task', //活动任务库存
    activeTaskStock: 'Level rewards goods', //关卡奖励商品
    activeTaskStock: 'Ranking award', //排名大奖

    brand: 'brand',
    shopNum: '店铺编号',
    activeEndTime: '活动结束日期',
    activeAuthPeople: '操作人',
    proStatus: '商品状态'
  },
  //  用户列表
  userAuth: {
    inputPlaceUserName: 'Please enter user name', //请输入用户名姓名
    inputPlaceAnthStatus: 'Please select an approval status', //请选择审核状态
    userName: 'Name', //姓名
    pass: 'Pass', //通过
    reject: 'Reject', //拒绝

    userList: '用户列表'
  },
  //  提现
  withdraw: {
    withdrawApplyTime: '提现申请时间',
    withdrawNum: '提现单号',
    withdrawType: '提现打款方式',
    withdrawOprateTime: '审核操作时间',
    IDCardName: '持卡人姓名',
    IDCardBank: '开卡银行',
    bankNum: '银行账号',
    export: '导出',
    IDname: '身份证/护照姓名',
    IDnum: '身份证/护照编号'
  },
  //  商家端字段补充
  merchant: {
    trademarkRights: 'Trademark permissions', //商标权限
    withdrawNum: 'Withdrawal order number', //提现单号
    withdrawType: 'Withdrawal credit method', //提现打款方式
    withdrawOprateTime: 'Audit operation time', //审核操作时间
    IDCardName: 'Cardholder name', //持卡人姓名
    IDCardBank: 'Bank of account', //开卡银行
    bankNum: 'Bank account number', //银行账号
    export: 'export', //导出
    IDname: 'ID/passport name', //身份证/护照姓名
    IDnum: 'ID/passport number', //身份证/护照编号
    businessLicenseFront: 'Upload business license（front）', //上传营业执照（正面）
    taxFileNumberFront: 'Tax number document（front）', //税号文件（正面）
    add: 'Add', //新增
    itemNo: 'Product number', //货号
    taskName: 'Task name', //任务名称
    shippingSettings: 'Shipping fee setting', //运费设置
    freeShipping: 'Free shipping', //包邮
    shippingTemplate: 'Shipping template', //运费模板
    selectedItems: 'Selected items', //已选择的商品
    selectedGifts: 'Selected gifts', //已选择的赠品
    selectedPro: 'Selected products', //选择商品
    selectedGifts2: 'Selected gifts', //选择赠品
    inputProName: 'Please enter product name', //请输入商品名称
    proBarcode: 'Product barcode', //商品条码
    addNewStorehouse: 'Add shipping warehouse', //新增发货仓库
    cancel: 'Cancel', //取 消
    confirm: 'Confirm', //确 定
    prizeSupplyPrice: 'Prize supply price', //奖品供货价
    submit: 'Submit', //提交
    productNumber: 'Product number', //商品编号
    lengthWidthHeight: 'length*wide*height(cm)', //长*宽*高(cm)
    harvestAddress: 'Receiving address', //收货地址
    distributionPackage: 'Assign parcel', //分配包裹
    shippingMethod: 'Shipping method', //运送方式
    logisticsCompanyName: 'Logistics company name', //物流公司名称
    shippingBillNumber: 'Shipping bill number', //发货运单号
    addPackage: 'Add package', //添加包裹
    userReceiptInformation: 'User receiving information', //用户收货信息
    latestDeliveryLeft: 'Latest shipment left', //最晚发货还剩
    totalCurrentOrder: 'Total current order', //当前订单共
    items: 'items', //件商品
    inputBrandName: 'Please enter the brand name', //输入品牌名称
    // 630 新加
    uploadFail10mb: 'Please upload a file of no more than 3MB', //请上传文件，且不超过10MB
    evidenceFails: 'Trademark acceptance certificate, trademark registration certificate, brand authorization certificate', //商标受理通知书，商标注册证书，品牌授权书
    owner1: 'Individual', //个人
    owner2: 'Enterprise', //企业
    TrademarkRights1: 'Fully held trade mark', //完全持有商标
    TrademarkRights2: 'Authorized Joint Venture', //授权合资公司
    TrademarkRights3: 'Authorized national agent', //授权国代
    tai: 'Thailand+66', //泰国+66
    zh: 'China+86', //中国+86
    en: 'USA+1', //美国+1
    inputTrueInfo: 'Please ensure that the information you fill in is true and valid', //请确保您填写的信息真实有效
    inputTrueInfoText: 'Please fill in the shop description, which will be displayed on the App brand shop profile', //请填写店铺介绍，这将展示App品牌店铺简介
    inputInfoTextLookOut: 'Note: you are limited to one change per month, please fill in carefully', //注意：每月仅限修改一次，请认真填写
    enterAndCheckTheTaxID: 'Enter and check your tax code', //输入并核对税号
    categoriesSelectedFitWithinRange:
      'The classification you choose must match the "goods/services" scope of the trademark, otherwise the audit may not pass', //选择的分类必须符合商标的"商品/服务"范围，否则审核可能不通过
    pleaseSelect: 'Please select', //请选择
    pleaseUpload: 'Please upload', //请上传
    areaCode: 'Area code', //区号
    brandCountry: 'Brand country', //品牌国家
    placeOrigin: 'Place of origin', //产地
    home: 'Domestic', //国内
    entrance: 'Import', //进口
    SuchPieceBox: 'eg pieces, boxes', //如个、件、箱
    inputSelectTierDistrict1: 'Please select Sub-district', //请选择一级行政区
    inputSelectTierDistrict2: 'Please select District', //请选择二级行政区
    inputSelectTierDistrict3: 'Please select Province', //请选择三级行政区
    inputUnitMeasurement: 'Please enter the unit of measurement', //请输入计量单位
    inputItemNumber: 'Please enter the item number', //请输入商品编号
    inputFreightTemplate: 'Please select a shipping template', //请选择运费模板
    newFreightTemplate: 'New shipping template', //新建运费模板
    refreshFreightTemplate: 'Refresh the latest shipping template', //刷新最新运费模板
    overtimeFree: 'Timeout free', //超时免单
    basicPolicyTitle1: 'The basic policy is mandatory and cannot be cancelled', //基本政策为必选项，不可取消
    basicPolicyTitle2: 'Select optional policy for actual situation', //针对实际情况选择可选政策
    basicPolicyTitle3: 'Please select according to the warehouse location', //请务必根据商品所在仓库进行选择
    nameConsignee: 'Consignee name/mobile phone number', //收货人姓名/手机号码
    all: 'All', //全部
    choseTime: 'Please select time', //请选择时间
    merchandiseOrder: 'Goods order', //商品订单
    afterSaleOrder: 'After sales order', //售后订单
    brandMultipleDeliveryWarehousesText: 'If multiple shipping warehouses exist for the brand, please re-add the item', //品牌若存在多个发货仓库请重新添加
    addNewWarehouseText: 'Add shipping warehouse', //新增发货仓库
    shopWater: 'Shop flow', //店铺流水
    withdrawList: 'Withdrawal records', //提现记录
    traList: 'Transaction history', //交易记录

    // --运费模板--7-3
    withdraw: 'Cash withdrawal amount', //提现金额
    goBack: 'Back', //返回
    withdrawChoseBank: 'Choose a bank card', //选择银行卡
    couldwidthdraw: 'Current account cash available for withdrawal', //当前账户可提现金额
    allwidthdraw: 'Withdraw all', //全部提现
    confirmWidthdraw: 'Confirm withdrawal', //确认提现
    widthdrawRules: 'Withdrawal rules', //提现规则
    widthdrawRules1:
      '1.The withdrawal will be credited within 24 hours. Withdrawals on statutory holidays will be automatically deferred to working days.', //1.提现打款周期为每周一次，每周五统一打款，如申请时间在打款时间之后，顺延到下个打款周期，请合理安排时间
    widthdrawRules2:
      "2. As the withdrawal is a service provided by the third party payment company, a 3% handling fee on the withdrawal amount will be charged according to the service standard. Now the platform is giving a bonus, the first year of merchants' membership is free and the withdrawal fee is temporarily set at 0", //2.因提现为第三方支付公司提供服务，按照服务标准提现需要收取提现金额3%的手续费，现平台给出红利，商家首年入驻免费，提现手续费暂定为0
    bankMng: 'Bank card management', //银行卡管理
    bankMngTitle:
      'Please fill in your account information carefully, if you fill in the wrong information to cause the loss of funds, the platform is not responsible', //请仔细填写账户信息，如果由于您填写错误导致资金流失，平台概不负责
    acquiesce: 'Default', //默认
    addBank: 'Add bank card', //新增银行卡
    idcardType: 'ID type', //证件类型
    idcardName: 'ID card name', //身份证姓名
    idcardNum: 'ID card number', //身份证号码
    idcardTime: 'ID card expiry date', //身份证有效期
    bankName: 'Bank name', //银行名称
    getVerifyNum: 'Get OTP', //获取验证码
    noteCheck: 'Please check！', //请注意查收！
    noteCheck2: 'SMS verification', //短信验证
    noteCheckToPhone: 'A verification SMS will be sent to your current account number', //验证短信将发送至您当前账号绑定的手机号
    suggestRetailPrice: 'Suggested retail price', //建议零售价
    quantitySold: 'Quantity sold', //销售数量
    orderMoney: 'order supply amount', //订单供货金额
    channelSaleServiceFee: 'Channel sales service fee', //渠道销售服务费
    ThreeFee: 'Third party payment commission fee', //第三方支付手续费
    chouponFee: 'Coupon credit amount', //优惠券抵扣金额
    activitiFee: 'Activity rewards service fee', //活动奖励服务费
    saleInFee: 'Sales amount credited', //销售入账金额
    saleAfterCode: 'After sales order number', //售后单号
    saleAfterSupplyGoodsFee: 'After sale return supply amount', //售后退回供货金额
    AfterSaleRefundChannelSaleServiceFee: 'after sale return channel sales service fee', //售后退回渠道销售服务费
    makeAmountDeductedCoupon: 'Return the coupon credit amount', //补回优惠券抵扣金额
    returnFreight: 'Return after sale shipping fee', //售后退回运费
    rewardServiceFeeAfterSaleActivity: 'Return the activity rewards service fee', //售后退回活动奖励服务费
    totalAmountReturnedAfterSale: 'Return the total amount', //售后退回总金额
    settlementAmount: 'Settlement amount', //结算金额
    totalStockIncludReplenishment: 'Total product inventory (including replenishment)', //商品总库存（包含补货）
    activeLockInventory: 'Locked stock in activities', //活动锁定库存
    remainAvailableStock: 'Remaining available stock', //剩余可用库存
    inventoryWarningQuantity: 'Number of stock alerts', //库存预警数量
    WarniTime: 'Warning time', //预警时间
    Tips: 'Tip', //提示
    TipsContent:
      'Shipping charged during the transaction will be calculated based on the shipping template settings selected when posting the item, you can also add', //交易过程中收取的运费会根据发布商品时选择的运费模板设置来计算，您还可以添加
    freeShipUnderSpecifieCondition: 'Specify conditions for shipping', //指定条件包邮
    lastEditTime: 'Last edit time', //最后编辑时间
    copyOne: 'Copy template', //复制模板
    detail: 'Details', //详情
    edit: 'Edit', //编辑
    del: 'Delete', //删除
    delBatch: 'Bulk delete', //批量删除
    transport: 'Shipping method', //运送方式
    canShipped: 'Can be shipped to', //可运送至
    firstPiece: 'First piece', //首件
    addFre: 'Add shipping cost', //增加运费
    defaultFre: 'Default shipping cost', //默认运费
    successor: 'Renewals', //续件
    renew: 'Renewal fee', //续费
    py: 'Surface mail', //平邮
    kd: 'Express mail', //快递
    tgyz: 'Thailand post', //泰国邮政
    TemplateName: 'Template name', //模板名称
    pricingMethod: 'Pricing method', //计价方式
    typeNumber: 'By piece', //按件数
    typeWeight: 'By weight', //按重量
    typeV: 'By volume', //按体积
    addOne: 'Per increase', //每增加
    batchSet: 'Batch setting', //批量设置
    batchOperate: 'Batch operation', //批量操作
    goTo: 'Ship to', //运送至
    shipSpecifiedCity: 'Set the shipping cost for the specified city', //为指定地区城市设置运费
    firstNum: 'First item（piece）', //首件（件）
    firstFee: 'First fee（in baht）', //首费（铢）
    secondNum: 'Renewal（piece）', //续件（件）
    secondFee: 'Renewal fee（baht）', //续费（铢）

    // 优惠券
    addCoupon: 'Add coupon', ///添加优惠券
    CouponsTipContent:
      'Coupons are divided into threshold and non-threshold coupons. The main functions are to increase the unit price, improve the repurchase rate and attract new and existing customers to form a purchase conversion', ///优惠券分为有门槛和无门槛优惠券，主要作用有提升客单价、提高回购率、吸引新老顾客形成购买转化。
    couponsFace: 'Coupon information', ///优惠券券面信息
    couponsName: 'Coupon name', ///优惠券名称
    font60: 'Up to 60 characters', ///最多不超过60个字符
    font100: 'Up to 100 characters', // 最多不超过100个字符
    faceVal: 'Face value', ///面值
    useConditions: 'Conditions of use', ///使用条件
    NoLimit: 'No limit', ///不限制
    orderAll: 'Order full', ///订单满
    validityPeriod: 'Validity period', ///有效期限
    groundRules: 'Basic rules', ///基本规则
    TotalAmountIssued: 'Total amount issued', ///发放总量
    CouponRestriction: 'Coupon restriction', ///领券限制
    BahtCanUsed: 'Baht, can be used', ///铢，可使用
    zhang: 'sheet(s)', ///张
    maximumNumberCoupons: 'Self-coupon limit per user, if not selected, defaults to 1 coupon', ///每个用户自助领券上限，如不选，则默认为1张
    allProJoin: 'All products are participated', ///全部商品参与
    NewlyReleasedProductsAdaptRule: 'Hint: Newly released products can also be adapted to this rule', ///提示：新发布的商品也能适应此规则
    PartialProJoin: 'Part of products are participated', ///部分商品参与
    remove: 'Remove', ///移除
    save: 'Save', ///保存
    goWhich: 'To', ///至
    addCoupon: 'Add coupon', ///新增优惠券
    BatchCancellation: 'Bulk voiding', ///批量作废
    claimRestriction: 'Claim restriction', ///领取限制
    PiecePerson: 'Sheet(s) per person', //张/人
    stock: 'Stock', //库存
    Claimed: 'Claimed', //已领取
    haveUsed: 'Used', //已使用
    status: 'Status', //状态
    proApply: 'Applicable items', //适用商品
    proEdit: 'Modify products', //修改商品
    cancellation: 'Void', //作废
    chosedPro: 'Selected item', //已选商品
    piece: 'Piece', //件

    // 优惠券遗漏
    collectionTime: 'Collection time', //领取时间
    useStatus: 'Usage status', //使用状态
    useTime: 'Use time', //使用时间
    couponType: 'Coupon type', //优惠券类型
    receiver: 'Recipient', //领取人
    receiveNum: 'Number of recipients', //领取数量
    detailAfterSaleOrder: 'After sales order details', //售后单详情
    batchOpen: 'Batch opening', //批量启用
    enable: 'Enable', //启用
    couponManagement: 'Coupon management', //优惠券管理
    afterSavCoupon:
      'After a coupon is saved, only the total number of coupons issued and the coupon limit can be edited and modified, please be careful', //优惠券保存后，只能对发放总量和领券限制做编辑修改，请谨慎操作
    receiptRecord: 'Receipt/use record', //领用/使用记录
    voidCoupon: 'Void coupon' //作废优惠券
  },
  //  商家端校验信息74
  merchantVerify: {
    pleaseSelectTrademarkRight: 'Please select trademark rights', //请选择商标权限
    pleaseSelectCountry: 'Please select a country', //请选择国家
    messageFontLong: 'Length between 2 and 140 characters', //长度在 2 到 140 个字符
    pleaseUploadLogoPicture: 'Please upload a logo picture', //请上传商标图片
    PleaseEnterTrademarkRegistration: 'Please enter your trademark registration number', //请输入商标注册号
    PleaseSelectBrandOwner: 'Please select the brand owner', //请选择品牌所有人
    PleaseEnterPhoneNumber: 'Please enter your mobile phone number', //请输入手机号
    PleaseEnterEmail: 'Please enter your email address', //请输入邮箱
    PleaseSupportingMaterials: 'Please add supporting materials', //请添加证明材料
    PleaseEnterCode: 'Please enter the area code', //请输入区号
    PleaseEnterContactPerson: 'Please enter a contact person', //请输入联系人
    PleaseSelectFirstDistrict: 'Please select Sub-district', //请选择一级行政区
    PleaseSelectSecondDistrict: 'Please select District', //请选择二级行政区
    PleaseSelectThirdDistrict: 'Please select Province', //请选择三级行政区
    PleaseEnterStoreDescription: 'Please enter a shop description', //请输入店铺简介
    PleaseUploadBusinessLicense: 'Please upload a business license', //请上传营业执照
    PleaseUploadTaxIDFile: 'Please upload tax ID file', //请上传税号文件
    PleaseEnteTaxID: 'Please enter your tax ID', //请输入税号
    PleaseUploadStoreLogo: 'Please upload shop logo', //请上传店铺商标/
    PleaseSelectProductCategory: 'Please select a product category', //请选择商品分类
    PleaseSelectCategoryEntry: 'Please select a category entry', //请选择分类入口
    PleaseSelectProperty: 'Please select the product type', //   请选择商品类型 1.5.12新增
    PleaseSelectVirtualGoods: 'Please select a virtual product type', // 请选择虚拟商品类型
    PleaseEnterProductName: 'Please enter a product name', //请输入商品名称
    PleaseEnterUnitMeasurement: 'Please enter the unit of measurement', //请输入计量单位
    PleaseEnterProductSubtitle: 'Please enter the product subtitle', //请输入商品副标题
    PleaseEnterSite: 'Please enter the address', // 请输入场地
    PleaseUploadProductMasterMap: 'Please upload the product master map', //请上传商品主图
    PleaseEnterProductCode: 'Please enter the product code', //请输入商品编码
    PleaseEnterSalesInformation: 'Please enter sales information', //请输入销售信息
    UploadProductDetailsMap: 'Upload product details map', //上传商品详情图
    messageFontLong2140: 'Length between 2 and 140 characters', //长度在 2 到 140 个字符
    PleaseEnterPriceItem: 'Please enter the price of the product', //请输入商品售价
    PleaseSelectProductBrand: 'Please select the product brand', //请选择商品品牌
    PleaseEnterProductDescription: 'Please enter the product description', //请输入商品介绍
    fieldRequired: 'This field is required', //该项为必填项
    PleaseEnterTaskName: 'Please enter the task name', //请输入任务名称
    PleaseEnterStartDate: 'Please enter the start date', //请输入开始日期
    PleaseEnterEndDate: 'Please enter the end date', //请输入结束日期
    RealNameAuthenticationInformation: 'Real name authentication information', //实名认证信息
    RealNameAuthentication: 'Real name authentication information', //实名认证
    bankCard: 'Bank card', //银行卡
    confirmInfo: 'Confirm information', //确认信息
    activityPro: 'Goods from activities', //活动商品

    logisticsCompany: 'logistics company',
    logisticsCompanyCode: 'logistics company Code',
    logisticsCompanyLogo: 'logistics company Logo',

    // 7-5号
    hour: 'Hour', //时
    min: 'Minute', //分
    second: 'Second', //秒
    salesRevenue: 'Sales revenue', //销售收入
    submitApplication: 'Submit application', //提交申请
    LookOnMove: 'Mobile details', //移动端详情
    PleaseSelectDocumentType: 'Please select document type', //请选择证件类型
    IdentificationCard: 'ID card', //身份证
    passport: 'Passport', //护照
    ChannelSalesServiceFee: 'Channel sales service fee', //渠道销售服务费
    ThirdPaymentCommission: 'Third party payment commission fee', //第三方支付手续费
    AmountDeductedMerchantCoupon: 'The amount of the merchant coupon credit', //商家优惠券抵扣金额
    PlatformCouponDiscountAmount: 'Platform coupon discount amount', //平台优惠券优惠金额
    QuantityAfterSaleOrder: 'Quantity of the after-sale order', //售后单数量
    AmounMerchantCoupon: 'The amount of the merchant coupon credit to be redeemed', //补回商家优惠券抵扣金额
    AmountPlatformCouponReturnedSale: 'The amount of the platform coupon returned after the sale', //售后退回平台优惠券优惠金额
    PassportName: 'Passport name', //护照姓名
    PassportNumber: 'Passport number', //护照号码
    PassportValidityPeriod: 'Passport validity period', //护照有效期
    SelectDate: 'Select date', //选择日期
    close: 'Close', //关 闭
    BrandSelfOperatStore: 'Branded self-operating stores', //品牌自营业店铺
    AfterSaleReceived: 'After sale received', //售后待收货
    refunded: 'To be refunded', //待退款
    AfterSaleCompletion: 'Aftersales completion', //售后完结
    due: 'To be paid', //待付款
    GoodsWaitSent: 'To be deliveried', //待发货
    shipped: 'Shipped', //已发货
    sendOutGoods: 'send out goods', // 发货  1.5.12新增
    completed: 'Completed', //已完成
    TargetClosed: 'Closed', //已关闭
    InvalidOrder: 'Invalid order', //无效订单
    H5Order: 'H5 order', //H5订单
    RegularOrder: 'Regular order', //正常订单
    AppOrder: 'APP order', //APP订单
    TaskDistributOrder: 'Profit distribution order from task', //任务分润订单
    TaskRewardOrder: 'Task reward order', //任务奖励订单
    RankingGrandPrizeAwardsOrder: 'Ranking Grand Prize Awards Orders', //排名大奖奖励订单
    chosePlace: 'Choose a place', //选择地区
    setShip: 'Set shipping conditions', //设置包邮条件
    WithinThe: 'Within' //内
  },
  //  运营端字段补充74
  operationEnd: {
    userList: 'user list',
    brandList: 'brand list',
    brandPlaceholder: 'please enter the brand name',

    //7-6
    BrandEntry: 'Brand Entry', //品牌录入
    ActivateStore: 'Activate shop', //激活店铺
    DeterministicClassification: 'Determine classification', //确定分类
    NotYetStarted: 'Not started', //未开始
    UnderWay: 'In progress', //进行中
    AlreadyEnded: 'Closed', //已结束
    AuditRejection: 'Audit rejected', //审核拒绝
    audited: 'Audited', //已审核
    CorporateTransfer: 'Corporate Transfer', //公司转账
    DirectWithdrawal: 'Direct withdrawal', //直接提现
    InApplication: 'In application', //申请中
    SuccessfulWithdrawal: 'Withdrawal successful', //提现成功
    WithdrawalFailure: 'Withdrawal failed', //提现失败
    BrandMerchant: 'Brand Merchant', //品牌商家
    WaitingClaimed: 'To be claimed', //待领取
    baht: 'THB', //铢
    baht1: 'THB, available', //铢，可使用
    ImportCertificateName: 'Import voucher name', //导入兑换券名称
    InventoryQuantity: 'Inventory quantity', //库存数量
    HaveImported: 'Imported', //已导入
    a: 'Pieces', //个
    code: 'Voucher status', //券码
    IssueStatus: 'Issue status', //发放状态
    CertificateValidityPeriod: 'Certificate validity period', //兑换券有效期
    ImportCode: 'Import coupon code', //导入券码
    CouponStatus: 'Voucher status', //优惠券状态
    RedeemPrizeVouchers: 'Redeem prizes/vouchers', //兑换奖品/券
    ExchangeType: 'Exchange Type', //兑换类型
    NameExchange: 'Name of the item to be redeemed', //兑换品名称
    shop: 'merchant', //商家
    PicExchange: 'Main picture of the redemption item', //兑换品主图
    PrizeValue: 'Prize value', //奖品价值
    PurchasePrice: 'Purchase price', //采购价
    RedeemPullNewValue: 'Redeem new user value', //兑换拉新用户值
    PerPersonLimit: 'Limit per person', //每人限兑
    ExchangeSpecification: 'Exchange specification description', //兑换细则描述
    CopyThe: 'Copies', //份
    PositiveMaximumValue9999: 'Positive integer only, no more than 9999', //只能填写正整数，不超过9999
    AddEdit: 'Add/Edit', //添加/编辑
    ExchangeCodeManagement: 'Exchange Code Management', //兑换券券码管理
    CreationTime: 'Creation time', //创建时间
    AfterPurchaseVoucher:
      'After the voucher has been purchased and imported through this module, the system will send a random voucher code according to the rules after the voucher has been successfully redeemed', //可到店消费的兑换券购买成功后，通过此模块导入，达人兑换成功后，系统根据规则随机发送券码
    NameCoupon: 'Name of the voucher', //兑换券名称
    VoucherBillNumber: 'Voucher code import number', //兑换券券码导入单号
    AddRedemptionCouponCode: 'Add redemption coupon code', //添加兑换券券码
    CouponCodeStart: 'Coupon start time', //兑换券起始时间
    TimeVoucher: 'End time of voucher', //兑换券结束时间
    DerivedCode: 'Derived voucher code', //导出券码
    AddPrizesVouchers: 'Add prizes/vouchers to be redeemed', //添加兑换奖品/券
    ShelfTime: 'Shelf time', //上架时间
    NameExchange: 'Name of the redeemed item', //兑换品名称
    validityPeriodCoupon: 'The validity period of the voucher', //兑换券有效期限
    PullUserValue: 'Refresh new user value', //拉新用户值
    ConversionStartTime: 'Redemption start time', //兑换开始时间
    ConversionEndTime: 'Redemption end time', //兑换结束时间
    ExchangeStatus: 'Exchange item status', //兑换品状态
    GiftExchangeManagement: 'Redeem gift management', //兑换礼品管理
    ReleasePrizesExchange:
      'Release the prizes and vouchers received by the person, after the release is successful, the person can only redeem the corresponding prizes and vouchers in the app', //发布达人领取的实物奖品和兑换券，发布成功后，达人在APP才能兑换相应奖品及兑换券
    replenishment: 'Replenishment', //补货
    delist: 'Delist', //下架
    QuantityPaid: 'Quantity redeemed', //已兑数量
    AllConverters: 'All redeemed items', //所有兑换品
    fillDeliveryAddress: 'Delivery address to be filled', //待填写收货地址
    received: 'Received', //已收货
    ExchangeOrderNumber: 'Exchange order number', //兑换单号
    ExchangeInformation: 'Exchange Information', //兑换品信息
    ConversionQuantity: 'Conversion quantity', //兑换数量
    TotalInventory: 'Total Inventory', //总库存
    ConvertedAmount: 'Converted count', //已兑换数
    ConversionTime: 'Conversion time', //兑换时间
    PrizeStatus: 'Prize status', //奖品状态
    TalentAccount: 'MXWINNER account', //达人账号
    ReceivingPhoneNumber: 'Receiving mobile number', //收货手机号
    addressProvinceCityDistrict: 'Receiving address: province-city-district', //收货地址：省-市-区
    MarkedDelivery: 'Marked delivery', //标记发货
    ModifyShipAddress: 'Modify shipping addres', //修改收货地址
    Guan: 'Stage',
    Guan1: 'Stage1',
    Guan2: 'Stage2',
    //  7-10
    tipsCreateBrandSelfStore: 'Please fill in the relevant information correctly, we will complete the audit within 3 working days', //请正确填写相关信息，我们将在3个工作日内完成审核
    confirm: 'Confirm', //确定
    concel: 'Cancel', //取消
    ValidUntil: 'Valid until', //有效期限至
    actualAmountReceived: 'The actual amount of funds that have been credited to the account', //实际打款到账金额
    DetailsCurrentAccountFunds: 'Current account fund details', //当前账户资金详情
    ConfirmPayment: 'Confirmed', //确认付款
    rejectPayment: 'Rejected', //拒绝付款
    PleaseEnterFeedback: 'Please enter feedback information', //请输入反馈信息
    AdditiveLogisticsCompany: 'Add logistic company', //添加物流公司
    Claimed: 'Claimed', //已领完
    CashCoupon: 'Coupon', //代金券
    PlatformCoupon: 'Platform coupon', //平台优惠券

    expired: 'Expired', //已过期
    cancelled: 'Voided', //已作废
    PhysicalPrize: 'Physical prizes', //实物奖品
    certificate: 'Exchange certificate', //兑换券
    WaitingUsed: 'To be used', //待使用
    invitationCode1: 'Add invitation code', //添加邀请码
    InvitationCodeType: 'Invitation code type', //邀请码类型
    InvitationCodeName: 'Invitation code name', //邀请码名称
    InvitationCode: 'Invitation code', //邀请码
    QuantityIssued: 'Number of issues', //发放数量
    DailyLimit: 'Daily limit', //每天限兑
    maxLimit60: 'Maximum 60 characters', //最多不超过60字符
    number4: 'Numbers with only 4 digits', //数字，只能填写4位数字
    choseTime: ' Select date and time', //选择日期时间
    RedEnvelope: 'Red packet', //红包闯关
    OpenBeta: 'Open beta', //公测
    FollowTime: 'Follow up time', //跟进时间
    BrandLocation: 'Brand place of origin', //品牌所属地
    FollowPeople: 'Followers', //跟进人
    WhetherFollow: 'Follower up or not', //是否跟进
    ContactName: 'Contact name', //联系人名称
    ContactNumber: 'Contact phone number', //联系人电话
    BrandOfficialWebsite: 'Brand official website', //品牌官网
    follow: 'Follow up', //跟进

    // 7-11
    PleaseRequiredFieldsCarefully: 'Please fill in the required fields carefully', //请认真填写必填项
    sort: 'Sort', //分类
    SupplyChainAlliance: 'Supply chain alliance', //供应链联盟
    BrandSelfSupport: 'Brand self-operated', //品牌自营
    skuCode1: 'SKU number', //SKU编号
    skuStock: 'SKU stock', //SKU库存
    CurrentStock: 'Current inventory', //当前库存
    DeleteOrder: 'Delete order', //删除订单
    signed: 'Signed', //已签收
    PayInstallments: 'Installment', //分期付
    nonPayment: 'Unpaid', //未支付
    BankcardPayment: 'Card payment', //银行卡支付
    ThirdPayment: 'Third party payment', //第三方支付
    Balancepayment: 'Balance payment', //余额付
    UploadVideo: 'Upload video', //上传视频
    ScreeningCondition: 'Filter conditions', //筛选条件
    ServiceOrderNumber: 'Service order number', //服务单号
    ApplicationStatus: 'Application status', //申请状态
    ProcessingTime: 'Processing time', //处理时间
    ProcessingState: 'Processing status', //处理状态
    operator: 'Operator', //操作人员
    // 7 -12
    OrdinaryTask: 'Ordinary tasks', //普通任务
    activeTask: 'Activity task', //活动任务
    BasicInformation: 'Basic information', //基本信息
    SalesAllocation: 'Sales configuration', //销售配置
    ServiceConfiguration: 'Service configuration', //服务配置
    Search: 'Search', //搜索
    completedAdd: 'Finish adding', //完成添加
    RefreshingSkuList: 'As refreshing the list will cause the sku information to be regenerated, are you sure to refresh it?', //刷新列表将导致sku信息重新生成，是否要刷新
    product: 'Product', //商品
    productTime: 'Task time', //任务时间
    inputPlacer: 'Input', //输入
    priceMoney: 'Prize', //价格
    day: 'Days', //天
    activeSecondTip: 'Activity subtitle', //活动副标题
    RankingReward: 'Ranking rewards', //排名奖励
    SelectedRankRewards: 'Selected ranking reward items', //已选择的排名奖励
    SelectRankRewardItems: 'Select ranking rewards', //选择排名奖励商品
    ensureNormalDisplay: 'To ensure normal display, the recommended list size is', //为确保正常显示，建议列表尺寸为
    PleaseSuccessUploaded:
      'Please wait until all images are uploaded successfully or if there is a network problem, please refresh the page to re-upload!', //请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！
    zhang1: '1 coupon', //1张
    zhang2: '2 coupons', //2张
    zhang3: '3 coupons', //3张
    zhang4: '4 coupons', //4张
    zhang5: '5 coupons', //5张
    zhang6: '6 coupons', //6张
    zhang7: '7 coupons', //7张
    zhang8: '8 coupons', //8张
    zhang9: '9 coupons', //9张
    zhang10: '10 coupons', //10张
    NotSubmitted: 'Not submitted', //未提交
    selfSupport: 'Self-operation', //自营
    article: 'models', //条
    KillOrder: 'Flash sale order', //秒杀订单
    Guan3: 'stage 3',

    // 7-17
    PleaseEnterNameImportCoupon: 'Please enter the name of the imported exchange voucher', //请输入导入兑换券名称
    FillNameMerchantOffersExchangeItem: ' Fill in the name of the merchant offering the redemption', //填写提供兑换商品的商家名称
    AfterSalePendReview: 'After-sale pending review', //售后待审核
    AfterSaleReceiving: 'After-sale receiving', //售后收货
    SubjectRefundAfterSale: 'After-sale pending refund', //售后待退款
    AfterSaleClosing: 'After-sale closed', //售后关闭
    examine: 'Review', //审核
    Declined: 'Declined', //已拒绝
    paid: 'Paid', //已付款
    createNow: 'Create now', //立即创建
    RechargeAccountBalance: 'Top up your account balance for public beta users', //给公测用户账户余额充值
    InvitationCodeDuration: 'Invitation code period', //邀请码期限
    InvitationCodeStatus: 'Invitation code status', //邀请码状态
    noFollowUp: 'Not followed', //未跟进
    HaveFollowed: 'Followed', //已跟进
    EventRewardServiceSetting: 'Activity reward service fee setting', //活动奖励服务费设置
    MerchantSupplyAmount: 'Merchant supply amount', //商家供货金额的
    RewardRatioSystemDefaults: 'If the common task reward percentage is empty, the system defaults to', //如果普通任务奖励比例为空，系统默认为
    OrderSetup: 'Order settings', //订单设置
    SystemAutomaticallyCloseOrder:
      'The system will automatically close the order if no payment is made within minutes. If the effective time is empty, the system defaults to 15 minutes', //分钟内不付款系统将自动关闭订单。如果生效时间为空，系统默认为15分钟
    AfterMakingOrder: 'After placing an order', //下单后
    OrderExpiratTime: 'Order expiry time', //订单失效时间
    CouponInformat: 'Coupon information', //优惠券信息
    TipAfterOpenUserReturns:
      'Tip: When it is turned on, the coupon used will be refunded after the user returns the goods; when it is turned off, the coupon used by the user to place the order will not be refunded. The system defaults to on.', //提示：开启后，用户退货后退还已使用的优惠券；关闭后，用户下单使用的优惠券不予退还。系统默认为开启状态
    QuantityPurchasePerItem: 'Quantity of single purchase for each product', //每个商品单次购买数量
    NotMoreThan: 'No more than', //不超过
    SinglePurchaseQuantityEachItemEmptySystemDefaults10:
      'If the number of single purchases per product is empty, the system defaults to 10', //如果每个商品单次购买数量为空，系统默认为10个
    VoucherUsageRules: 'Voucher usage rules', //代金券使用规则
    AfterClaiming: 'After receiving', //领取后
    ValidDefaultValue3Days: 'Valid within XX days. If the expiration time is empty, the system defaults to 3 days.', //天内有效。如果失效时间为空，系统默认为3天
    VoucherUseConditions: 'Voucher usage conditions', //代金券使用条件
    ValueVoucher: 'Voucher denomination', //代金券面额
    BahtOrderAmountFull: 'Baht, for orders over', //铢， 订单金额满
    BahtOrderAmountFull2: 'Baht', //铢可用
    AdditionalRule: 'Add rules', //增加规则
    MaximumCanAdded: 'Maximum 8 can be added', //最多可添加8个

    // 7-18
    NormalQuestReward: 'Normal task rewards', //普通任务奖励
    ActivityLevelReward: 'Activity level reward', //活动关卡奖励
    activityLevelRewardRatioEmpty: 'If the event level reward scale is empty, the system defaults to', //如果活动关卡奖励比例为空，系统默认为
    RankingAwards: 'Prize reward', //排名大奖奖励
    PrizeRewardRatioEmptySystemDefaults: 'If the Ranking Reward percentage is empty, the system defaults to', //如果排名大奖奖励比例为空，系统默认为
    WithdrawalFeeSetting: 'Withdrawal fee setting', //提现手续费设置
    On: 'On', //开启
    Off: 'Off', //关闭
    TipsWithdraw:
      '(Tip: After switching on, the handling fee will be deducted when the merchant withdraws money, the amount of money in the account = the amount of cash withdrawn - handling fee. When it is closed, no handling fee will be deducted when the merchant withdraws cash, and the amount of cash in the account will be equal to the amount of cash withdrawn. The system is closed by default. In the open state, if the withdrawal fee is empty, the system defaults that the fee is 3%) The system will automatically close the order if no payment is made within minutes. If the effective time is empty, the system defaults to 15 minutes', //（提示：开启后，商家提现时要扣除手续费，到账金额=提现金额-手续费；关闭后，商家提现时不扣除手续费，到账金额=提现金额。系统默认为关闭状态；开启状态，如果提现手续费为空，系统默认手续费为3%）分钟内不付款系统将自动关闭订单。如果生效时间为空，系统默认为15分钟
    UserWithdrawalFee: 'Handling fee for user withdrawal:', //用户提现手续费
    TipsWithdraw2:
      '(Tip: When it is turned on, the handling fee will be deducted when the user withdraws cash, and the amount of money in the account = the amount of cash withdrawn - the handling fee. After switching off, no handling fee will be deducted when the user withdraws cash, and the amount of cash in the account will be equal to the amount of cash withdrawn. The system default is on. (If the handling fee for cash withdrawal is empty, the system defaults the handling fee to 3%)', //（提示：开启后，用户提现时要扣除手续费，到账金额=提现金额-手续费；关闭后，用户提现时不扣除手续费，到账金额=提现金额。系统默认为开启状态，如果提现手续费为空，系统默认手续费为3%）
    RedEnvelopeCrossTaskSet: 'Red packet mission settings', //红包闯关任务设置
    ValidityTorrentUserQualification: 'Potential user qualification validity period', //种子用户资格有效期
    redPackageTips:
      'If the validity period of potential user qualification is empty, the system defaults to 7 days. After the expiration date, the qualification will be invalidated and no more qualification will be granted.', //如果种子用户资格有效期为空，系统默认为7天。逾期资格失效，不再获得闯关资格
    redEntryQualificatValid: 'Red packet qualification validity period', //红包闯关资格有效期
    month: 'month', //月
    year: 'year', //年
    redPackageTips2:
      'If the qualification period is empty, the system defaults to 180 days. After the expiry date, the qualification will be invalidated and users will no longer get the red package reward', //如果闯关资格有效期为空，系统默认为180天。逾期资格失效，不再获得红包奖励
    RedActivityLevelSettings: 'Red packet activity level settings', //红包闯关活动关卡设置
    BonusAmount: 'Bonus amount', //奖励红包金额
    THB: 'Baht', //泰铢
    if: 'If', //如果
    redAmountEmptySystemDefaults: 'Bonus Amount is empty, the system defaults to', //奖励红包金额为空，系统默认为
    crosredEnvelopeLevelSet: 'Bonus level setting of red packet activity', //红包闯关红包层级设置
    InviteUsersFull: 'Invite new users', //邀请新用户满
    redEnvelopeRewardPlatformServiceSingleItem: 'Each red packet reward = platform service fee for a single product', //每个红包奖励=单个商品的平台服务费

    // 7-20
    CashedOut: 'Done', //已兑完
    batchAuth: 'Batch audit', //批量审核
    TaskActivityStatisticsPeriod: 'Task/activity count period:', //任务/活动统计期:
    TaskActivityDue: 'Task/activity prize claiming overdue:', //任务/活动逾期:
    TaskActivityStatisticsPeriodEnd: 'After the task/activity end period, the statistics period is', //任务/活动结束时期后，统计期为
    TaskActivityStatisticsPeriOverdue: 'After the task/activity end period, the prize claiming overdue period is', //任务/活动结束时期后，领奖逾期为
    MissionActivityRewardPeriod7: 'day(s), if the task/activity statistic period is empty, the system defaults to 7 days', //天，如果任务/活动统计期为空，系统默认为7天
    MissionActivityRewardPeriod8: 'day(s).If the task/activity prize collection overdue time is empty, the system defaults to 8 days', //天，如果任务/活动领奖逾期时间为空，系统默认为8天
    awardTimeSet: 'Prize Claiming time setting' //领奖时间设置
  },

  //  7.26号后添加的提示语
  supplementaryPrompt: {
    pleaseAddOne: 'Please add at least one category entry!', //请至少添加一个分类入口！！
    pleaseAddLast: 'Please finish filling out the last category entry first', //请先填写完上个分类入口
    pleaseAddLevelNotNull: 'Category cannot be empty, please fill in the category carefully!', //分类不能为空，请认真填写分类!
    ClassificationNotRepeated: ' Categories cannot be duplicated!', //分类不能重复！
    PleaseEnterFullAddress: 'Please enter the detailed address', //请输入详细地址
    PleaseSelectRegion: 'Please select the region', //请选择所在地区
    PleaseEnterPostalCode: 'Please enter the postcode', //请输入邮编
    PleaseEnterAdministratorName: 'Please enter administrator name', //请输入管理人名称
    PleaseEnterContactNumber: 'Please enter a contact phone number', //请输入联系电话
    PleaseEnterWarehouseName: 'Please enter warehouse name', //请输入仓库名称
    VideoUploadedSuccessfully: 'Video uploaded successfully!', //视频上传成功！
    PleaseSelectOperationType: 'Please select operation type', //请选择操作类型
    PleaseSelectProductWantOperate: 'Please select the product you want to operate', //请选择要操作的商品
    WhetherPerformBatchOperation: 'Whether to perform this batch operation?', //是否要进行该批量操作?
    WhetherModifyIt: 'Whether to modify it?', //是否要进行修改?
    SkuInformationAvailable: 'No sku information', //暂无sku信息
    ModifiedSuccessfully: 'Modified Successfully!', //修改成功！
    OrderShipSuccessfully: 'Order shipped successfully!', //订单发货成功！
    PleaseChecKItemsAssignPackages: 'Please tick the product that need to be assigned a parcel!', //请勾选需要分配包裹的商品!
    WarmReminder: 'Warm reminder', //温馨提示
    ValidityPeriod:
      'Due to the imminent expiry of the validity of your documents, you can not bind the cash withdrawal bank card. It is recommended to apply for a new license as soon as possible, or choose another bank card to bind the cash withdrawal!', //您的证件有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！
    ValidityPeriod1:
      'Due to the imminent expiration of the validity of your card, you can not bind the cash withdrawal bank card. It is recommended to apply for a new card as soon as possible for replacement, or select another bank card to bind withdrawals!', //您的银行卡有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！
    PleaseSelectBankCard: ' Please choose a bank card!', //请选择银行卡！！
    WithdrawalSubmitSuccessfully: 'Withdrawal application submitted successfully!', //提现申请提交成功！
    BankCardBindSuccessful: 'Bank card binding success!', //银行卡绑定成功！
    PleaseFillBankName: 'Please fill in the bank name', //请填写银行名称
    PleaseFillCardHolderName: 'Please fill in the name of the cardholder', //请填写持卡人姓名
    PleaseFillName: 'Please fill in your name', //请填写姓名
    BankAccount25Digits: 'Bank account number should be less than 25 digits!', //银行账号需小于25位数！
    PleaseFillBankAccountNumberOnly: 'Please fill in the bank account number and it can only be numbers!', //请填写银行账号且只能为数字！
    PleaseOnlyNumbers: 'Please fill in the bank account number and it can only be numbers!', //请填写银行账号且只能为数字！
    your: '', //您的
    validityPeriodAboutExpire:
      'Due to the imminent expiry of the validity period, it is not possible to bind the bank card used for cash withdrawals. It is recommended to apply for a new license for replacement as soon as possible, or choose another bank card for binding cash withdrawal!', //有效期即将过期，无法绑定提现银行卡。建议尽快办理新的证照进行更换，或者选择其他银行卡进行绑定提现！
    CancelCouponWillCancelled:
      'Voided coupons. Unclaimed coupons are voided. The user can not continue to collect it. Are you sure to void the coupon?', //作废优惠券，未领取的优惠券会作废，不能继续领取，是否作废？
    SuccessfulCancellation: 'Successfully voided!', //成功作废！
    PleaseSelectContentFirstBatchOperation: 'Please select the content first, then do the batch operation!', //请先选中内容，再做批量操作！
    CancelCouponsBatches:
      'Voided coupons in batches. Unclaimed coupons are voided. The user can not continue to collect it. Are you sure to void the coupon in batches?', //批量作废优惠券，未领取的优惠券会作废，不能继续领取，是否批量作废？
    editSuccess: 'Edit successfully!', //编辑成功！
    GoodsEditSuccessfully: 'Modify the product successfully!', //修改商品成功！
    CouponValidityPeriod: 'Coupon expiry date', //优惠券有效期
    PleaseEnterTotalAmountIssued: 'Please enter the total amount of coupons issued', //请输入发放总量
    PleaseCouponValidityPeriod: 'Please enter the validity period of the coupon', //请输入优惠券有效期
    EnabledSuccessfully: 'Enabled successfully', //启用成功！
    InvalidDataEnabledSuccessfully:
      'Voided data enabled successfully! When expired data is enabled, you need to update the expiry date of the coupon first!', //已作废的数据启用成功！已过期的数据启用时，需要更新优惠券的有效期限后，才能启用！
    DoDelCouponsBulk: 'Whether to delete coupons in batches?', //是否批量删除优惠券？

    //  7-28
    processed: 'Pending', //待处理
    ReturningGoods: 'Returns in progress', //退货中
    GiveawayStockSmallerAvailableStock: 'Gift inventory to be less than available inventory!', //赠品库存要小于可用库存！
    PleaseFillGiftInventory: 'Please fill in the give inventory!', //请填写赠品库存！
    endDateGreaterStartDate: 'The end date has to be later than the start date!', //结束日期要大于开始日期！
    endDate7OlderStartDate: 'The end date cannot be later than the start date by more than 7 days!', //结束日期不能大于开始日期超过7天！
    PleaseSelectProduct: 'Please select the product!', //请选择商品！
    PleaseFillInventory: 'Please fill in the product inventory!', //请填写商品库存！
    taskInventorySmallerAvailableInventory: 'Task inventory has to be less than available inventory!', //任务库存要小于可用库存！
    ActivityAudit: 'Activity Review', //活动审核
    ConvertibilityPeriod: 'Convertibility period', //可兑换期限
    PleaseEnterExchangeVoucher: 'Please enter the name of the product/coupon', //请输入兑换品/兑换券名称
    PleaseEnterMerchant: 'Please enter a merchant', //请输入商家
    PleaseUploadExchangeCouponMasterChart: 'Please upload the main image of the prize/voucher', //请上传兑换品/兑换券主图
    PleaseEnterPrizeVoucher: 'Please enter the value of the prize/coupon', //请输入奖品/兑换券价值
    PleaseEnterPurchasePrice: 'Please enter the purchase price', //请输入采购价
    PleaseSelectCoupon: 'Please Select Voucher', //请选择兑换券
    PleaseEnterNewUserValueRedemption: 'Please enter the value of new users for the exchange', //请输入兑换拉新用户值
    PleaseEnterInventoryQuantity: 'Please enter the value of new users for the exchange', //请输入兑换拉新用户值
    PleaseFillExchangeDescription: 'Please fill in the description of the redemption details', //请填写兑换细则描述
    PleaseFillStartDate: 'Please fill in the start date', //请填写开始日期
    PleaseFillEndDate: 'Please fill in the end date', //请填写结束日期
    PrizeDeliveryManagement: 'Prize delivery management', //奖品发货管理
    PrizeDeliveryManagementTips:
      'Prize delivery management. Physical prizes and coupon prizes will be automatically issued to the MXWINNER is prize account after redemption.', //奖品发货管理，实物奖品和兑换券奖品在达人兑换后，会自动发放到达人奖品账户中
    ConversionTime: 'Conversion time', //兑换时间
    ConsigneeArea: 'Consignee area', //收货人区域
    ExchangeOrderNumber: 'Redemption order number', //兑换单号
    remaining: 'Remaining', //还剩
    TimeOut: 'Timeout', //已超时
    SetInventory: 'Set inventory', //设定库存
    QueryResult: 'Query result', //查询结果
    ActiveTime: 'Activity time', //活动时间
    IncentiveStock: 'Prize inventory', //奖励库存
    PrizeInventory: 'Grand prize inventory', //大奖库存
    AddBankCard: 'Add bank card', //添加银行卡
    amountDeductedPlatformCoupon: 'Platform coupon credit amount', //平台优惠券抵扣金额
    ReimburseAmountMerchantCoupon: 'Replenish merchant coupon credit amount', //补回商家优惠券抵扣金额
    ConfirmShip: 'Confirm and ship', //确认并发货
    EditWaybill: 'Edit the waybill', //编辑运单
    ConfirmDelivery: 'Confirm shipment', //确认发货
    parcel: 'Parcel', //包裹

    // 8-1
    AddedLevelCategoryEntry1: 'Adding a first level category entry', //新增一级分类入口
    PleaseEnterFirstLevelCategoryEntryName: 'Please enter the name of the first level category entry', //请输入一级分类入口名称
    FirstClassClassificatEntry: 'First class category entry', //一级分类入口
    FirstClassClassificatEntry2: 'Second class category entry', //二级分类入口
    FirstClassClassificatEntry2Num: 'Second class category entry number', //二级分类入口数量
    reveal: 'Reveal', //显示
    sort: 'Sort', //排序
    NewSecondaryClassificate: 'Add a new secondary category', //新增二级分类
    NewFirstClassificatCommodities: 'Add first class category of product', //新增商品一级分类
    PleaseEnterProductCategoryName: 'Please enter the name of product first class category', //请输入商品一级分类名称
    PrimaryClassificatCommodities: 'Product first classification', //商品一级分类
    SecondaryClassificatCommodities: 'Product second classification', //商品二级分类
    SubordinateQuantity: 'Subordinate quantity', //下级数量
    NewSecondaryClassificatCommodity: 'Add second class category of product', //新增商品二级分类
    EnterFirstClassNameProduct: 'Please enter the name of product first class category', //输入商品一级分类名称
    view: 'View', //查看
    ClassificationName: 'Category name', //分类名称
    verify: 'Confirm', //确认
    PayAttentPlatformClassificatRule: 'Pay attention to the platform category rules', //注意平台分类规则
    UpperCategory: 'Upper level category', //上级分类：
    EditSpecification: 'Edit specification', //编辑规格
    PleaseEnterInvitationCodeName: 'Please enter invitation code name', //请输入邀请码名称
    PleaseSelectInvitaCodeType: 'Please enter invitation code type', //请选择邀请码类型
    PleaseEnterInvitatCode: 'Please enter invitation code', //请输入邀请码
    OnlyDigitsCanEntered4: 'Only 4 digits can be filled in', //只能填写4位数字
    PleaseEnterPrizeValue: 'Please enter the value of the prize', //请输入奖品价值
    UpDigits6: 'Maximum 6 digits', //最多6位数
    PleaseEnterReleaseQuantity: 'Please enter the number of prizes to be issued', //请输入发放数量
    PleaseEnterStartDate: 'Please enter the start date', //请输入开始日期
    PleaseEndDate: 'Please enter the end date', //请输入结束日期
    CreatedSuccessfully: ' Created successfully!', //创建成功！
    lengthLessCharacters60: 'Length less than 60 characters', //长度小于60字符
    PleaseSelectCouponValidityPeriod: 'Please select the validity period of the voucher', //请选择兑换券有效期
    RemovedSuccessfully: 'Removed successfully!', //移除成功！
    unissued: 'Not issued', //未发放
    WaitingUsed: 'To be used', //待使用
    // 8-4
    RedEnvelopeValueThreeLevels: 'Total value of the three levels of Red Packet activity', //红包闯关资格三关总价值
    IndividualShop: 'Personal shop', //个人店铺
    input: 'Input', //输入
    CorrespondingGoods: 'Corresponding product', //对应商品
    BarCode: 'Barcode', //条码

    // 8-7新
    deliveryModeExpressTemplate:
      'For all courier templates under Shipping Method, the Default Shipping Template Settings field is required!', //运送方式下所有快递模板，默认运费模板设置字段必填！
    EditingSuccess: 'Edit Success!', //编辑成功！！
    CreatedSuccessfully: 'Created successfully!', //创建成功！！
    PleaseFillImportCountryCarefully: 'Please fill in the import country carefully!', //请认真填写进口国家！
    PleaseRegionsOriginCarefully: 'Please fill in the third level administrative region of origin carefully!', //请认真填写产地的三级行政区！
    PleaseRefreshPageSelectStoreAgain: 'Please refresh the page to re-select the shop!', //请刷新页面重新选择店铺！
    PanningPrice: 'MXWINNER price', //淘金价
    PlatformPrice: 'MXCOME price', //平台价格
    PlatformProfit: 'Platform profit', //平台利润
    TalentProfit: 'MXWINNER profit', //达人利润
    ViewShipTemplateDetails: 'View shipping template details', //查看运费模板详情
    propertyValueCannotEmpty: 'Attribute value cannot be empty', //属性值不能为空
    PleaseParametersSpecificaTemplate: 'Please fill in the parameters in the specification template first', //请先在规格模板中填写参数！
    PleaseSelectShipTemplate: 'Please select the shipping template!', //请选择运费模板！
    specificationTemplateSaleInformat: 'Please fill in the specification template and sales information carefully!', //请认真填写规格模板和销售信息！！
    PleaseFillSKUCode: 'Please fill in the SKU code carefully!', //请认真填写SKU编码
    PleaseFilSupplyPrice: 'Please fill in the supply price carefully', //请认真填写供货价
    PleaseFillSuggestedPrice: 'Please fill in the suggested selling price carefully', //请认真填写建议售价
    PleaseFillPrice: ' Please fill in the MXWINNER price carefully', //请认真填写淘金价
    goldRushPriceGreaterSupplyPrice: 'The MXWINNER price should be greater than the supply price.', //淘金价应大于供货价
    PleaseFillInventory: 'Please fill in the inventory', //请认真填写商品库存
    PleaseFillProductLength: 'Please fill in the length of the product', //请认真填写商品长度
    PleaseFillProductWidth: 'Please fill in the width of the product', //请认真填写商品宽度
    PleaseFillProductHeight: 'Please fill in the height of the product', //请认真填写商品高度
    PleaseFillGrossWeight: 'Please fill in the gross weight of the product carefully', //请认真填写商品毛重
    WhetherAuditProduct: 'Whether to review the product', //是否要审核该产品
    SubmitSuccess: 'Submited successfully', //提交成功
    WhetherSubmitProduct: 'Whether to submit the product', //是否要提交该产品
    FillNameMerchantOffers: 'Fill in the name of the merchant providing the exchange product', //填写提供兑换商品的商家名称
    ExchangeLOGO: 'Redemption Logo', //兑换品LOGO
    MasterChartRedemptionNotes: 'Redemption coupon main picture', //兑换券主图
    Maximum1Photo1M: 'Maximum 1 photo with format jpg or png or bmp, each not more than 3MB', //最多1张，照片支持格式jpg，png，每张不超过1M
    Maximum4Photo1M: 'Maximum 4 photo with format jpg or png or bmp, each not more than 3MB', //最多4张，照片支持格式jpg，png，每张不超过1M
    AddSuccessful: 'Added successfully', //添加成功
    PleaseSelectProductFirst: 'Please select the product first', //请先选择商品
    CancelUnclaimedCouponWhetherCancel: 'Void coupon, unclaimed coupon will be void, and can not continue to receive, whether to void', //作废优惠券，未领取的优惠券会作废，不能继续领取，是否作废
    CodeTypeOpenTestPrizeMandatory: 'When the invitation code type is Public Test, the prize value is required!', //邀请码类型为公测时，奖品价值为必填项！！
    DailyLimitGreaterThanAmountIssued: 'The daily limit of redemption cannot be greater than the total amount issued!', //每天限兑不能大于发放总量！
    PleaseEnterNumber: 'Please enter numbers!', //请输入数字！！
    withdrawalAmountWithdrawalAmount: 'Withdrawal amount cannot exceed the withdrawable cash amount!', //提现金额不能超过可提现金额！！
    withdrawalAmountCannotbe0: 'The cash withdrawal amount cannot be 0!', //提现金额不能为0！
    ShippingTime: 'Time of Delivery',
    ReceiptTime: 'Time of Receipt',
    // 8-9
    withdrawalAmountCannotbe0: 'The withdrawal amount cannot be 0!', //提现金额不能为0！
    PleaseEnterAdministratorName: 'Please enter administrator name', //请输入管理人名称
    PleaseEnterLogisticsCompanyName: ' Please enter the name of the logistics company', //请输入物流公司名称
    NoMoreThan3Packages: 'Parcel can not be more than 3', //包裹不能超过3个
    ShippingWaybillNumberEmpty: 'Sending freight bill number can not be empty!', //发货运单号不能为空！！
    DeleteItPleaseExerciseCaution: 'Are you sure you want to delete? Please be cautious!', //确定要删除吗？请谨慎操作！
    SuccessfullyDelete: 'Deleted successfully!', //成功删除!
    PleaseFillOrderHowManyBahtUsed: 'Please fill in how many baht the order can be used!', //请填写订单满多少铢可使用！
    AddCouponSuccessfully: 'Add coupon successfully!', //添加优惠券成功！！
    ImportSuccessfully: 'Imported successfully!', //导入成功
    inventoryNotbe0: 'Inventory quantity cannot be 0!', //库存数量不能为0！
    PleaseSelectActiveArea: 'Please select the activity area', //请选择活动区域
    SelectCoupon: 'Select coupon', //选择兑换券
    CouponLOGO: 'Voucher logo', //兑换券LOGO
    couponcodeGroupAddedCouponCodeManagement: 'Select the voucher code group added in [Voucher Code Management].', //选择【兑换券券码管理】中添加的兑换券券码组
    valueVoucher: 'Voucher value', //兑换券价值
    PleaseEnterInteger: 'Please enter an integer!', //请输入整数!
    No4MainImages: 'The main picture cannot exceed 4!', //主图不能超过4张!
    SaveSuccessfully: 'Save successfully!', //保存成功!
    CurrentDeliveryAddress: 'Current shipping address', //当前收货地址
    ExchangeGoodsReplenishment: 'Redeem restock', //兑换品补货
    ConfirmRedeemPrizeShelf: 'Make sure this redemption prize is stocked', //确定将此兑换奖品上架
    stockPleaseRestockContinuShelves: 'Insufficient stock, please restock before continuing to shelve!', //库存不足，请先补货再继续上架！
    SuccessShelves: 'Uploaded successfully!', //上架成功！
    ConfirmRedemptionPrizeOffShelf: 'Determine to remove this redemption from the shelves.', //确定将此兑换奖品下架
    RemovedSuccessful: 'Replenishment success!', //下架成功!
    ReplenishmentSuccess: 'Restocked successfully!', //补货成功!
    ConfirmDelivery: 'Confirm shipping!', //确定发货!
    TrackingNumber: 'Express Order Number', //快递单号!
    PleaseFillLogisticsCompanyName: 'Please fill in the name of the logistics company!', //请填写物流公司名称!
    deleteConverterWhetherBatchDelete: 'Batch deletion, whether to delete in batch', //批量删除兑换品，是否批量删除!
    BatchDeletionSucceeded: 'Batch delete success!', //批量删除成功!
    DeliverySuccess: 'Shipment successful!', //发货成功!
    PhysicalPrizeInformat: 'Physical prize information!', //实物奖品信息!
    value: 'Value', //价值
    expire: 'Expire', //到期
    HaveAlreadyBeen: 'have(has) already been', //已在
    DeliverGoods: 'Shipped', //发货
    ReceiveGoods: 'Received', //收货
    validity: 'Validity', //有效期
    TotalConsumptionUserValues: 'Total consumed pull new user value', //共消耗拉新用户值
    full: 'full', // '满'
    available: 'available', //'可用'
    // 8-14
    PartialGoods: 'Partial goods', //部分商品
    AllGoods: 'All products', //全部商品
    TobeListed: 'To be listed', //待上架
    AlreadyListed: 'Already listed', //已上架
    NoLongerAvailable: 'Dropped', //已下架
    RealNameAudit: 'Real name audit', //实名审核
    PleaseConfirmAuthenticationUserMatchesIDInformation:
      'Please make sure that user information by real name authentication matches the ID information', //请确认实名认证用户信息与证件信息匹配
    UserData: 'User information', //用户资料
    RealName: 'Real name', //真实姓名
    RegisteredMobilePhone: 'Registered mobile phone', //注册手机
    // 8-17
    ChangeProductHasCreatedTask:
      'Tasks have already been created for this product. The task validity period remains consistent and does not need to be manually set again', //该商品已经创建了任务，任务有效期保持一致，不需要再手动设置
    ConfirmTemplateDeletion: 'Confirm deleting the template?', //确认删除模板？
    CopyTemplateSuccessful: 'Copy template successfully!', //复制模板成功！！
    wholeCountry: 'The whole country', //全国
    ExceptDesignatedAreas: 'Except for the specified regions, the shipping cost for the rest of the country will be the "Default"', //除指定地区外，其余地区的运费采用“默认运费”
    DefaultTemplate: 'Default template', //默认模板
    CancelBatch: 'Bulk cancellation', //取消批量
    FreePostageBaht: 'Baht free shipping', //铢包邮
    // // 8-18
    // StoreAudit: 'Shop audit', //店铺审核
    // ShopInformation: 'Shop information', //店铺信息
    // PleaseStoreBrandBusinessInformation: 'Please confirm the shop brand and business information', //请确认店铺品牌及经营信息
    // BrandInformation: 'Brand information', //品牌信息
    // LevelReward: 'Level rewards', //关卡奖励
    // 8-21
    GrowthMissionsOnlySelect3SPUs: 'In the growth tool of ordinary tasks, you can only select 3 SPU at most! !', //普通任务的增长工具最多只能选择3个spu！！
    QuestOnly3SpuItemsPerLevel: 'For task goods, there can only be 1-3 SPU goods per level! !', //任务商品每关只能有1-3个spu商品！！
    RankingRewardsUpTo5SKUs: 'Rank rewards up to 5 SKUs! !', //排名奖励最多5个sku！！
    ActivityLevelRewardsUpTo3SPUs: 'The activity level rewards up to 3 SPU! !', //活动关卡奖励最多3个spu！！
    NormalQuestItemsOnlyAddOneSpu: 'Only one SPU can be added for ordinary task goods at most!', //普通任务商品最多只能添加一个spu！
    AddUser: 'Add user', //添加用户
    Type: 'Type', //类型：
    AccountNumber: 'ID:', //账号：
    AccountNumber1: 'ID', //账号
    Name: 'Name:', //姓名：
    Name1: 'Name', //姓名
    email: 'E-mail:', //邮箱：
    password: 'Password:', //密码：
    remark: 'Remark:', //备注：
    WhetherEnable: 'Is it enabled', //是否启用
    merchant: 'Merchant', //商家
    Administrator: 'Administrator', //管理员
    AddTime: 'Add time', //添加时间
    LastLogin: 'Last login', //最后登录
    AssignRoles: 'Assign roles', //分配角色
    yes: 'Yes', //是
    no: 'No', //否
    PleaseFillAccountNumber: 'Please fill in the ID', //请填写帐号
    PleaseFillAccountName: 'Please fill in Name', //请填写姓名
    PleaseFillAccountEmail: 'Please fill in the Email', //请填写邮箱
    PleaseFillAccountPassword: 'Please fill in the Password', //请填写密码
    searchView: 'Query', //查询搜索
    RoleName: 'Role name', //角色名称
    Description: 'Description', //描述
    UserNumber: 'Number of users', //用户数
    AllocateResources: 'Allocate Resources', //分配资源
    DistributionMenu: 'Distribution Menu', //分配菜单
    WhetherSubmitData: 'Whether to submit data', //是否提交数据
    // 822
    EditUser: 'Edit user', //编辑用户
    PleaseLeast1ItemPerLevel: 'Please set at least one task product for each level!', //每关请至少设置1个任务商品！
    PleaseLeastTwoLevels: 'Please set at least 2 levels!', //请至少设置两关！
    ServiceOrderNumber: 'Service order number', //服务单号
    MenuName: 'Menu name', //菜单名称
    MenuProgression: 'Menu Series', //菜单级数
    FrontEndName: 'Front end Name', //前端名称
    FrontEndIcon: 'Front end Icon', //前端图标
    ShoworNot: 'Show or not', //是否显示
    sort: 'Sort', //排序
    Settings: 'Settings', //设置
    ViewSubordinates: 'View Lower Level', //查看下级
    UpperMenu: 'Upper Level Menu', //上级菜单：
    ResourceName: 'Resource Name', //资源名称
    ResourcePath: 'Resource Path', //资源路径
    ResourceClassification: 'Resource Classification', //资源分类
    PleaseSelectMenu: 'Please select a menu', //请选择菜单
    clear: 'Clear', //清空
    // 830
    LabelOption: 'Options', //标签选项
    EditSwitchPricingMethod: 'You cannot switch the pricing method in the editing state!', //编辑状态不可切换计价方式！
    EditSwitchPricingMethod2:
      'After switching the pricing method, the shipping information of the current template set will be cleared. Are you sure you want to continue?', //切换计价方式后，所设置当前模板的运输信息将被清空，确定继续么？
    weightChose: 'Weight', //重量
    WeightAmountChose: 'Weight + amount', //重量+金额
    AmountChose: 'Amount', //金额
    pieceChose: 'Number of pieces', //件数
    pieceAmountChose: 'Number of pieces + amount', //件数+金额
    StoreAudit: 'Shop audit', //店铺审核
    ShopInformation: 'Shop information', //店铺信息
    PleaseStoreBrandBusinessInformation: 'Please confirm the shop brand and business information', //请确认店铺品牌及经营信息
    BrandInformation: 'Brand information', //品牌信息
    LevelReward: 'Level rewards', //关卡奖励

    // 9-8
    OperationalEntry: 'Log in', //运营登录
    entry: 'Log in', //登录
    ByContinuReadAgree: 'By continuing, you agree to', //继续即表示您已阅读并同意
    MXCOMEWord: 'MXCOME Service Agreement and Privacy Notice', //《MXCOME商家服务协议与隐私政策》
    PleaseSelectLoginShop: 'Please select your shop' //请选择登录店铺
  },
  //  1.5.5 调价
  adjustPrice: {
    onSale: 'On sale', //在售中
    soldOut: 'Sold out', //已售罄
    cumulativeSales: 'Cumulative sales', //累计销量
    shelfStatus: 'On-sale status', //上架状态
    FreeOrNot: 'Gift or not', //是否赠品
    ReleaseGoods: 'Release goods', //发布商品
    SupplyPriceAdjustment: 'Supply price asjustment', //供货价调价
    ShelfBulk: 'Batch put on sale', //批量上架
    BatchRemoval: 'Batch pull off shelves', //批量下架
    notSet: 'Not set', //未设置
    ModifyPrice: 'Modify price', //修改价格
    totalSalesVolume: 'Total sales', //总销量
    video: 'Video', //视频
    review: 'Re-audit', //重新审核
    supplyPriceAdjustRequestForm: 'Supply Price Adjustment Request Form', //供货价调价申请单
    originalSupplyPrice: 'Original supply price', //原供货价
    currentSupplyPrice: 'Current supply price', //现供货价
    EffectiveDate: 'Effective date', //生效日期
    ProductID: 'Product ID', //商品ID
    GoldRushPriceAdjust: 'MXCOME price adjustment', //淘金价调价
    commodityInformation: 'Product information', //商品信息
    shop: 'Shop', //店铺
    product: 'Product', //商品
    giveaway: 'Gift', //赠品
    // 9-19
    appGoldPriceAdjust: 'MXCOME price Adjustment Request Form', //淘金价调价申请单
    originalPanningPrice: 'Original MXCOME price', //原淘金价
    cashRushPrice: 'Current MXCOME price', //现淘金价
    priceAdjustmentApplicationTime: 'Price adjustment request time', //调价申请时间
    priceAdjustmentNumber: 'Price adjustment list no.', //调价单号
    supplyPriceAdjustmentListNumber: 'Supply price adjustment list no.', //供货价调价单号
    AuditTime: 'Audit time', //审核时间
    auditStatus: 'Audit status', //审核状态
    auditor: 'Auditor', //审核人
    typePriceAdjustment: 'Type of price adjustment', //调价类型
    EffectiveTime: 'Effective time', //生效时间
    goldPriceAdjustOrderNumber: 'MXCOME price adjustment list no.', //淘金价调价单号
    passivePriceAdjust: 'Passive price adjustment', //被动调价
    voluntaryPriceAdjust: 'Active price adjustment', //主动调价
    platformServiceFee: 'Platform service fee', //平台服务费
    TalentAward: 'MXWINNER Award', //达人奖励
    priceAdjustmentInformation: 'Adjustment form information', //调价单信息
    supplyPriceAdjustmentInformation: 'Supply price adjustment form information', //供货价调价单信息
    supplyPriceAdjustDetailsPanPriceSet: 'Supply price adjustment details and MXCOME price setting', //供货价调价详情及淘金价设置
    panningPriceSet: 'MXCOME price setting', //淘金价设置
    commoditiesPriceAdjust: 'Products with adjusted price', //已调价的商品
    productPicture: 'Pictures of products', //商品图片
    priceAdjustmentRatio: 'Price Adjustment Rate' //调价比率
  },
  //  开通品牌，店铺
  openBrandShop: {
    phone: 'Phone Number', //'电话'
    AdministratorName: "Administrator's name", //'管理员姓名'
    AdministratorPhone: "Administrator's phone", //'管理员电话'
    AdministratorEmail: "Administrator's email", //'管理员邮箱'
    affidavitTime: 'Expiration of Affidavit', //'宣誓书到期时间'
    AboutExpire: ' Expiring soon', //'即将到期'
    ExpiredLicense: 'License expired', //'证照过期'
    abnormal: 'Abnormal', //'异常'
    SupplementaryInformation: 'Supplementary information', //'补充资料'
    uploadBanner: 'Upload banner image', //'上传banner图'
    AdministratorInformation: "Administrator's information", //'管理员信息'
    mobile: 'Phone Number', //'手机'
    MailingAddress: 'Mailing address', //'邮寄地址'
    maximum30Characters: 'Maximum 30 characters', //'最多不超过30个字符'
    openBrandShopTip1: 'Please fill in the shop introduction. Note: Only modified once a month, please fill in carefully', //'请填写店铺介绍，展示APP品牌店铺简介。注意：每月仅修改一次，请认真填写'
    SelectiveClassification: 'Select Classification', //'选择分类'
    haveClassification: 'Select Classification', //'选择分类'
    NewCategory: 'Add new category', //'新增分类'
    CauseRejection: 'Reason for rejection', //'驳回原因'
    reEdit: 'Re-edit', //'重新编辑'
    recertification: 'Re-authentication', //'重新认证'
    DataAuthentication: 'Data authentication', //'资料认证'
    openBrandShopTip2:
      'Please upload the relevant information according to the actual situation, you can also activate the shop after the additional information', //'请根据实际情况上传相关资料，您也可激活店铺后补充'
    BrandInformation: 'Brand Profile', //'品牌资料'
    BrandParty: 'Brand', //品牌方
    JointVentureCompany: 'Joint Venture', //'合资公司'
    StateAgent: 'Country Agent', //'国家代理'
    TrademarkApplication: 'Trademark Application', //'商标申请书'
    brandTrademarkAuthorization: '(Brand) Trademark Certificate of Authorisation', // '(品牌)商标授权书'
    TrademarkCertificate: 'Trademark certificate', //'商标证书'
    CompanyInformation: 'Company Information', //'公司资料'
    SupportingMaterial: 'Certificates', //'证明材料'
    SignatureDirector: "Director's signature", //'董事签署'
    AuthorizedSignature: 'Authorized Signature', //'授权签署'
    CertificateIncorporation: 'Certificate of Incorporation', //'公司登记证书'
    CompanyCertificateNumber: 'Certificate of Incorporation No.', //'公司登记证书号'

    // 10-14
    Limited30Characters: 'Limited to 30 characters', //限30个字符
    companyAffidavit: 'Business Registration Certificate', //公司宣誓书
    EffectiveCutoffTime: 'Valid until', //有效截止时间
    VATRegistrationCertificate: 'VAT Registration Certificate', //增值税登记证
    VATregistrationNumber: 'VAT registration number', //增值税登记号码
    openBrandShopTip3:
      'Upload the certificate as: The Certificate of Value Added Tax registration (Form Por.Por.20) (new company provides Form Por.Por.01)', //上传证照为：ภ.พ. 20 （新公司就提供ภ.พ.01）
    DirectorPowerAttorney: "Director's Authorization", //董事授权书
    NameDirectorNameAuthorizRepresent: 'Name of Director, Name of Authorized Representative', //董事名字，授权代表名字
    ImmediateAuthentication: 'Certify now', //立即认证
    ApplicantInformation: 'Applicant information', //申请人信息
    BrandOwnership: 'Brand owned', //品牌所有
    RelatedWebsite: 'Related websites', //相关网站
    NameAuthoriRepresent: 'Name of Director, Name of Authorized Representative', //董事名字、授权代表名字
    goNext: 'Skip', //跳过
    CertificationData: 'Authentication Information', //认证资料
    BrandStoreName: 'Brand/Store Name', //品牌/店铺名称
    AuditType: 'Audit Type', //审核类型
    AddBalance: 'Add Balance', //添加余额
    UserRegistrationCreationTime: 'User Registration/Creation Time', //用户注册/创建时间
    AcquisitionChannel: 'Acquisition channel', //获取通道
    SubscriberMobilePhoneNumber: "User's mobile phone number", //用户手机号
    userName: 'User name', //用户姓名
    firstPurchaseTime: ' First purchase time', //首单购买时间
    WhetherRedEntryQualification: 'Qualification for red packet activity?', //是否有红包闯关资格
    inviter: 'Inviter', //邀请人
    UserNickname: 'User Nickname', //用户昵称
    OpenBetaInvitationCode: 'Public Test Invitation Code', //公测邀请码
    RedEnvelopeEntryInvitationCode: 'Invitation code of red packet activity', //红包闯关邀请码
    ShareBuying: 'Share purchase', //分享购买
    InvitationInvitationCode: 'Invitation and invitation code', //邀请函邀请码
    RedEnvelopeQualificaManagement: 'Red packet management', //红包资格管理
    RedEnvelopeQualificaManagement2:
      'Red packet qualification background management module, the operator can also use this module to manually add red packet qualification to the user.', //红包闯关资格后台管理模块，运营还可以通过此模块手动给用户添加红包闯关资格
    TotalOrderNumber: 'Total number of orders', //总订单数
    totalNumberPackages: 'Total pieces', //总件数
    TotalAmountGoldPanningSales: 'Total amount of MXCOME sales', //淘金销售总金额
    TotalAmountRedPacketsMasterLevel: 'Total amount of red packets for the MXWINNER', //达人层级红包总金额
    TalentPromotionAward: 'MXWINNER promotion reward', //达人推广奖励
    balanceTalentAccountRecorded: 'MXWINNER account balance credited', //达人账户余额入账
    MasterGoldReward: 'MXCOIN reward', //达人金币奖励
    numberReturnedItems: 'Total number of returned goods', //退货总件数
    TotalAmountReturned: 'Total amount of returned goods', //退货总金额
    bindingBankcardTip1:
      'You need to select the bank corresponding to the bank card when binding the bank card. This module is mainly customized to add bank information in the system background', //绑定银行卡时需要选择银行卡对应的银行，该模块主要是在系统后台自定义添加银行信息
    AddBank: 'Add bank', //添加银行
    BankAbbreviation: 'Bank short name', //银行简称
    BankLogo: 'Bank logo', //银行Logo
    lengthCannotExceed60Characters: 'No more than 60 characters', //长度不超过60个字符
    lengthCannotExceed20Characters: 'No more than 20 characters', //长度不超过20个字符
    PleaseFillBankAbbreviat: 'Please fill in the short name of the bank', //请填写银行简称
    PleaseFillBankLogo: 'Please fill in the bank logo', //请填写银行Logo
    LoginAccount: 'Login account', //登录账号
    hongbaoEligibilityPeriod: 'Red packet entry qualification period', //红包资格期限
    addedRedPacketEntryQualificate: 'Add qualification for red packet activity', //添加红包闯关资格
    ManualAddition: 'Add manually', //手动添加
    EligibilityPeriod: 'Eligibility Period', //资格有效期
    QuantityAudited: 'Number of qualifications to be reviewed', //待审核数量

    // 10-16
    WhetherSetUpLocalOperatCompany: 'Whether to set up a local operating company', //是否设立本地运营公司
    copyTip1: 'Copy link success', //复制链接成功
    englishOrNum: 'Can only be numbers or English', //只能为数字或英文
    Num30: 'Cannot exceed 30 characters', //不能超过30个字符
    GoldRushSalesPaidOut: 'Actual payment amount of MXCOME sales', //淘金销售实付金额
    // 10-23
    OnlyMP4FormatSupportedTips:
      'Only MP4 format is supported, and the size of the video must not exceed 50M. It is recommended that the video size is 1080*1400 or equivalent ratio', //仅支持MP4格式，视频大小不可超过10M，建议视频尺寸为1080*1400或等比例为最佳
    InvitationLetter: 'Invitation letter', //邀请函
    InvitationLetter: 'Open brand operation', //开启品牌自营
    OpenBrandStore: 'Open brand store', //开通品牌店铺
    ContactName: 'Contact name', //联系人姓名

    picTips: 'The size of a single image does not exceed 3MB, and upload up to 5 images, supporting jpg, png, bmp format', //单张图片大小不超过3MB，最多上传5张，支持jpg、png、bmp格式
    editNot: 'The specification template in editing state can not be edited!', //编辑状态规格模板不可被编辑！
    Not60String: 'No more than 60 characters', //长度不超过 60 个字符
    Not100String: 'No more than 100 characters', // 长度不超过 100 个字符
    AudiComplete: 'Review completed', //审核完成!
    activeAuth: 'Activity review', //活动审核
    userAuth: "User's real name review", //用户实名审核
    shopBrandAuth: 'Brand shop audit', //品牌店铺审核
    proAuth: 'Product review', //商品审核
    SupplyPriceAdjustReview: 'Supply price adjustment review', //供货价调价审核
    GoldRushPriceAdjustReview: 'MXCOME price adjustment review', //淘金价调价审核
    BrandApplicatReview: 'Brand application review', //品牌申请审核
    ServiceApplicatFollowUp: 'Service application follow-up', //服务申请跟进
    EnterMultipleQueriesSequenceSeparatedCommas: 'For multiple queries, please separate them with commas and enter them in order', //多个查询请逗号隔开依次输入
    PleaseEnterEffectiveDate: 'Please enter the effective date', //请输入生效日期
    PleaseSelectProduct: 'Please select the product!', //请选择商品！
    PleaseFillCashPanPrice: 'Please fill in the MXCOME price!', //请填写现淘金价！
    PleaseFillCashPanPriceTip2:
      'The current MXCOME price must be greater than the current supply price, or there will be a loss of assets!', //现淘金价必须大于现供货价，否则会造成资损！
    PleaseFillCashPanPriceTip3: 'The MXCOME price adjustment request is successful!', //淘金价调价申请成功！
    PleaseFillCashPanPriceTip4:
      'The product has already been submitted with a pending price adjustment order. If a price adjustment request is submitted again, the most recently submitted price will prevail', //商品已经提交了一个待审核的调价单，本次再次提交调价申请，会以最近一次提交的价格为准
    PleasFillCurrentSupplyPrice: 'Please fill in the current MXCOME price', //请填写现供货价！
    SupplyPriceAdjustApplicatSuccessful: 'The supply price adjustment request is successful!', //供货价调价申请成功

    // 10-26
    PleaseEnterAccountNumber: 'Please enter account number', //请输入账号
    PleaseEnterPassword: 'Please enter a password', //请输入密码
    AccountNumberName: 'Account number/Name', //帐号/姓名
    ServiceType: 'Service type', //服务类型
    FillMobilePhoneNumberMasterRegistrate: 'Fill in the mobile phone number registered by the MXWINNER', //填写达人注册的手机号
    EnglishNumberMaximum30Characters: 'English, numbers, English+number, no more than 30 characters', //英文、数字、英文+数字，最多不超过30个字符
    memberPhone: 'MXWINNER mobile phone number', //达人手机号
    inputMemberPhone: 'Please enter the mobile phone number of MXWINNER', //请输入达人手机号
    Up60Characters: 'No more than 60 characters', //最多60个字符
    EditSaveSuccess: 'Edited and saved', //编辑保存成功！
    PleaseSelectStoreFirstProceedOperation: 'Please select the shop first before proceeding!', //请先选择店铺后，再进行操作！
    WhetherDeleteBank: 'Do you want to delete the bank?', //是否要删除该银行?
    delSuccess: 'Delete successfully!', //删除成功！
    editBank: 'Edit the bank', //编辑银行
    ServiceName: 'Service name', //服务名称
    AuditDetails: 'Review Details', //审核详情
    HaveEntered: 'Whether it has been entered', //是否已入驻
    numPerlimitTip: 'The quantity issued and the daily redemption limit need to be a positive integer greater than or equal to 1!', //发放数量和每天限兑需大于等于1的正整数！
    numPerlimitTip3:
      'The product has already been submitted with a pending price adjustment order. If a price adjustment request is submitted again, the price of the most recent submission will prevail.', //商品已经提交了一个待审核的调价单，本次再次提交调价申请，会以最近一次提交的价格为准

    // 11-1
    ViewExamples: 'View examples', //查看示例
    certificateInformatSubmitSuccess:
      'Certification information submitted successfully. It will be reviewed within 48 hours. Only after the audit is approved, can the products be put on the shelves!', //认证资料提交成功，将在48小时内审核完毕，审核通过后，才能上架商品！
    toDoThisDelete: 'Do you want to delete?', //是否要进行该删除操作?
    activatStoreAuthenticatInformatSuccessfulSubmit:
      'The certification information to activate the shop was submitted successfully. It will be reviewed within 48 hours. Products can only be created after the audit is passed!', //激活店铺认证信息提交成功，将在48小时内审核完毕，审核通过后，才能创建商品！
    activatStoreAuthenticatInformatSuccessfulSubmit2:
      'In order to better protect your legitimate rights and interests, please read the following agreement.', //为了更好地保障您的合法权益，请阅读以下协议:
    brandInfoAgain: 'Brand Profile Recertification submitted successfully. It will be reviewed within 48 hours!', //品牌简介重新认证提交成功，将在48小时内审核完毕！
    brandInfoAgain2:
      'Before the expiry of the affidavit, you need to update it in [Supplementary Information], otherwise all products will be taken down and cannot be sold normally!', //宣誓书到期前，需要在【补充资料】更新宣誓书，否则所有商品会全部下架无法正常销售！
    home: 'Homepage', //首页
    quit: 'Exit', //退出
    CloseOther: 'Close others', //关闭其他
    CloseAll: 'Close all', //关闭所有
    AlreadyEnter: 'Already enter', //已入驻
    NotYetEnter: 'Unlisted', //未入驻
    corporateServices: 'Enterprise services', //企业服务
    OperationService: 'Operational services', //运营服务
    package: 'Packages', //包裹
    selfSupport: 'Self-operated', //自营
    BatchImport: 'Batch import', //批量导入
    DownloadTemplate: 'Download templates', //下载模板
    ToLeadInto: 'Import', //导入
    ImportList: 'Import list', //导入名单
    CouponCodeInformat: 'Coupon code information', //券码信息
    zhangCan: 'coupon(s) available for use', //张可用

    // 11-2
    NewFirstLevelClassificat: 'Add a new primary classification', //新增一级分类
    EditPrimaryClassifica: 'Edit primary classification', //编辑一级分类
    EditPrimaryClassifica2: 'Edit secondary classification', //编辑二级分类
    EditFirstClassificatGoods: 'Edit product primary classification', //编辑商品一级分类
    EditCommoditSecondaryClassificat: 'Edit product secondary classification', //编辑商品二级分类
    CategoryNamecn: 'Category name(cn)', //分类名称(cn)
    CategoryNameen: 'Category name(en)', //分类名称(en)
    CategoryNameth: 'Category name(th)', //分类名称(th)
    PrimaryClassificatCommoditiesCn: 'Product primary classification(cn):', //商品一级分类(cn)：
    PrimaryClassificatCommoditiesEn: 'Product primary classification(en):', //商品一级分类(en)：
    PrimaryClassificatCommoditiesTh: 'Product primary classification(th):', //商品一级分类(th)：
    guigeData: 'Specification data', //规格数据
    guigeName: 'Specification name', //规格名称
    choseList: 'Optional list', //可选列表
    addNewParam: 'Add parameter', //新增参数
    addNewGuige: 'Add specification', //新增规格

    // 11-3
    // ManualInput: "ป้อนข้อมูล",
    // SelectBox: "ตัวเลือก",
    // PleaseSelectRegion: 'กรุณาเลือกพื้นที่ที่ต้องการจัดการหลายรายการ  ',
    // TicketCodeNumber: 'รหัสคูปอง',
    // AlreadyExist: 'มีอยู่แล้ว',
    // needDeleteDataImportTemplateImportAgain: 'ต้องลบรหัสคูปองดังกล่าวออกจากไฟล์ก่อน แล้วลองนำเข้าไฟล์อีกครั้ง',
    NetRedTalentRedEnvelopeCrosTask: 'Settings of red packet activity for MXWINNER KOL',
    // 11-9
    activatStoreAuthenticatInformatSuccessfulSubmit2:
      'In order to better protect your legitimate rights and interests, please read and agree to the following agreement', //为了更好地保障您的合法权益，请阅读并同意以下协议:
    PleaseEnterYourName: 'Please enter your name', //请输入姓名
    PleaseEnterYourContactEmail: 'Please enter your email address', //请输入联系邮箱
    congeniality: 'Agree', //同意
    PleaseUploadStoreLogo: 'Please upload the shop logo', //请上传店铺logo
    PleaseFillFullAddress: 'Please fill in the detailed address', //请填写详细地址
    PleaseFillLeastOneField: 'Please fill in at least one item before submitting, otherwise please click Skip!', //请至少填写一项内容后再提交，否则请点跳过！
    PleaseFillTheCategory: 'Please fill in the category!', //请填写分类！
    DuplicateBrandName: 'Brand name exists', //品牌名称重复！
    PleaseSelectCategory: 'Please select a category', //请选择分类
    PleaseFillMailAddressCareful: 'Please fill in the mailing address carefully!', //请认真填写邮寄地址！

    PleaseEnterActivityName: 'Please fill in activity name carefully', //"请认真填写邮寄地址！",
    PleaseEnterActivitySubtitle: 'Please enter the subtitle of the event', //"请输入活动副标题",
    lengthBetween140Characters: '4 to 140 characters in length', //"长度在 4 到 140 个字符",

    // 11-15
    FeedbackPerson: 'Feedbacker', //反馈人
    FeedbackTime: 'Feedback time', //反馈时间
    FeedbackType: 'Feedback type', //反馈类型
    source: 'Source', //来源
    ImprovementSuggest: 'Improvement suggestion', //改进建议
    Off: 'Off', //关闭
    SupplyPriceAdjustRequestSubmit: 'Supply price adjustment request form submitted successfully', //供货价调价申请单提交成功
    PleaseEnterTemplateName: 'Please enter a template name', //请输入模板名称
    PleaseSelectShipAddress: 'Please select shipping address', //请选择发货地址
    AreWantDeleteSetCurrentRegion: 'Are you sure to delete the current region setting?', //确认要删除当前地区的设置么？
    MerchandiseReconciliaState: 'Merchandise reconciliation form', //商品对账表
    SalesStatement: 'Sales report', //销量报表
    InventoryWarning: 'Inventory alert', //库存预警
    InventoryInquiryReport: 'Inventory enquiry report', //库存查询报表
    AfterSalePendingReview: 'Pending review', //售后待审核
    Limited60Characters: 'Maximum 60 characters', //限60个字符
    InteractiveSuggest: 'Interaction suggestion', //交互建议
    FunctionalSuggest: 'Function suggestion', //功能建议
    BUGSubmission: 'BUG submission', //BUG提交
    others: 'Others', //其他
    ProductsMeetConditionsRemove: 'Items cannot be taken down because they do not meet the conditions for being taken down!', //商品不符合下架条件，不能被下架!
    BowWeight: 'First Weight(kg)', //首重量(kg)
    BowV: 'First Volume(m³)', //首体积(m³)
    BowWSecond: 'Continued weight(kg)', //续重量(kg)
    BowVSecond: 'Continued Volume(m³)', //续体积(m³)
    RedEnvelopeEntryTaskName: 'Red packet breakout task name', //红包闯关任务名称
    EligibilityPeriodMandatory: 'Eligibility period is required', //资格有效期为必填项
    Cleared: 'Cleared', //已通关
    recoveredAfterBeingDeleted: 'Data cannot be recovered after deletion, so please proceed with caution!', //删除后，数据无法恢复，请谨慎操作！
    AgreeRefund: 'Agree to refund', //同意退款
    CloseOrder: 'Close order', //关闭订单
    sureAgreeRefund: 'Are you sure to refund?', //确定同意退款？
    RefundSuccessful: 'Refund successful!', //退款成功！
    //  12-1
    ScheduleVisit: 'Book a visit', //预约来访时间
    MakeSureFollowService: 'Make sure the service has been followed up!', //确定已经跟进该项服务！
    FollowUpComplete: 'Follow-up is complete!', //跟进完成！
    WebNet: 'Official website', //官网
    read: 'Noted', //已读
    readNot: 'Unnoted', //未读
    CreateEditTime: 'Create/edit time', //创建/编辑时间
    AddTask: 'Add task', //添加任务
    nameSuper: 'Name', //名称
    choseTask: 'Select task', //选择任务
    SelectedTask: 'Selected task', //已选任务
    CommodityType: 'Product type', //商品类型
    PackageGoods: 'Package product', //套餐商品
    GeneralMerchandise: 'Ordinary product', //普通商品
    EditingTask: 'Edit tasks', //编辑任务

    BrandManage: 'Band management', //'品牌管理',
    ShopManage: 'Shop management', //'店铺管理',
    proManage: 'Product management', //'商品管理',
    taskManage: 'Task management', //'任务管理',
    activeManage: 'Activity management', //'活动管理',
    orderManage: 'Order management', //'订单管理',
    // 12-4
    welcome: 'Welcome', //欢迎
    WelcomeMXCOMEMerchantOperationConsole: 'Welcome to the MXCOME Merchant Operations Console', //欢迎来到MXCOME商家运营控制台
    ActivateBrandedStore: 'Activate your brand shop', //激活您的品牌店铺
    ProvidePutGoodsShelves:
      'Merchants will be able to list their products after providing complete certification information and passing the audit', //提供完整的认证资料，审核通过后，即可上架商品
    ActivateNow: 'Activate now', //立即激活
    BrandStoreReviewed: 'Brand shop opening in the state of pending audit', //品牌店铺开通待审核
    openingInformationBrandStore:
      'Brand shop opening information has been submitted which will be audited within 48 hours. When the audit is passed, the products can be on the shelves', //品牌店铺开通资料已提交，将在48小时内审核完成，待审核通过后，即可上架商品
    setWarehousAddress: 'Set warehouse address', //设置仓库地址
    setShipTemplates: 'Set shipping template', //设置运费模板
    AddBrandStores: 'Add brand shop', //增设品牌店铺

    // 12-18
    PromoterNickname: "Please enter the promoter's nickname", //请输入推广人昵称
    noMore50string: 'No more than 50 characters', //不能超过50个字符
    lianceCode: 'Alliance invitation code', //联盟邀请码
    thai: 'Thailand', //泰国
    china: 'China', //中国
    salaryRangePositiveInteger2: 'Salary range needs to be positive', //薪资区间需为正数
    idcardNum2: 'ID/Passport number', //身份证/护照号码
    DeleteVideo: 'Delete video', //删除视频
    VideoDeletionSuccessful: 'Video deleted successfully!', //视频删除成功!
    promoterRegisterMobileNumber: "Promoter's registered mobile phone number", //推广人注册手机号
    registerMobilePhoneNumber: 'Fill in the registered mobile phone number', //填写注册的手机号
    PromoterNickname2: "Promoter's nickname", //推广人昵称
    promoterNicknameEnglishOnly: "Fill in the promoter's name or nickname in English", //填写推广人的姓名或昵称，只能输入英文
    AuthorizationType: 'Authorization type', //授权类型
    ApplicationType: 'Application type', //申请类型
    articleReprint: 'Article repost', //文章转载
    ContenReference: 'Content citation', //内容引用
    copyrightLicenseApplicationDetails: 'Copyright license application details', //版权授权申请详情
    requirement: 'Requirement', //需求
    FollowSuccessful: 'Succeed in following up', //跟进成功
    influencerJoinApplicatDetails: 'Application details for online celebrity joining', //网红加入申请详情
    screenshotDayChannel: 'Screenshots from the channel of the day', //当日频道截图
    ReleaseTime: 'Publish time', //发布时间
    Base: 'Base', //Base地
    RecruitmentDepartment: 'Recruitment department', //招聘部门
    JobTitle: 'Position name', //岗位名称
    DeliveryTime: 'Delivery time', //投递时间
    NatureWork: 'Nature of work', //工作性质
    ContactLocation: 'Region of contact people living', //联系人所在地区
    EducationalRequire: 'Educational requirements', //学历要求
    fullTime: 'Full-time', //全职
    PartTimeJob: 'Part-time', //兼职
    practice: 'Internship', //实习
    PostReleaseTime: 'Posting time', //岗位发布时间
    viewResume: 'View resume', //查看简历
    PostJobRequirements: 'Post a job request', //发布岗位需求
    JobExperience: 'Job experience', //岗位经验
    YearsMore: 'More than years', //年以上
    SalaryRange: 'Salary range', //薪资区间
    JobDescription: 'Job description', //岗位描述
    FailureTime: 'Failure time', //失效时间

    // 12-21
    curriculumVitae: 'Resume', //简历
    JuniorCollege: 'Associate degree', //大专
    SeniorHighSchool: 'Senior high school degree', //高中
    UndergraduateCourse: "Bachelor's degreee", //本科
    master: "Master's degree", //硕士
    LearnedScholar: 'PhD', //博士
    PleaseSelectBasePlace: 'Please select base', //请选择Base地
    PleaseRecruitmentDepartment: 'Please enter the Recruitment Department', //请输入招聘部门
    PleaseSelectExpirationTime: 'Please select the Expiry Time', //请选择失效时间
    PleaseEnterJobExperience: 'Please enter Job Experience', //请输入岗位经验
    PleaseEnterJobDescription: 'Please input Job Description', //请输入岗位描述
    PleaseSelectJobType: 'Please select the Job Type', //请选择工作性质
    PleaseEnterJobTitle: 'Please enter the Job Name', //请输入岗位名称
    PleaseEnterSalaryRange: 'Please enter salary range', //请输入薪资区间
    PleaseSelectEducationalRequirements: 'Please select the Educational Requirements', //请选择学历要求

    //  12-26
    MerchantWithdrawalFeeSetting: 'Merchant withdrawal fee:',
    RedEnvelopeEntryQualificatDeadline: 'Deadline for qualifying for the Red Packet Activity', //红包闯关资格截止日期
    overdueQualificatInvalidRedEnvelopeReward:
      'If it expires, the qualification will be invalid and you will no longer receive the bonus reward', //逾期资格失效，不再获得红包奖励
    totalEligibilityPeriod: 'Total qualification period', //资格有效期共计

    netRedTalentTaskSet: 'Task setting for online celebrity', //网红达人闯关任务设置
    GoldRushTalenRedEnvelope: 'MXWINNER red packet activity', //淘金达人红包闯关
    InternetCelebrityTalentRedEnvelope: 'Online celebrity red packet activity', //网红达人红包闯关
    netRedTalentRedEnvelopCrossActivityLevelSet: 'Red packet activity level setting for online celebrity', //网红达人红包闯关活动关卡设置
    netCelebrityRedEnvelopeQualificatValidPeriod: 'Qualification period of Red packet activity level for online celebrity', //网红达人红包闯关资格有效期限
    redEnvelopeEligibilityValidityPeriod: 'Red packet expiry date', //红包资格有效期限
    addedRedEnvelopeQuest: 'Add a task on red packet activity', //添加红包闯关任务
    startTime: 'Start time', //起始时间

    // 1.6版本 新加
    AddBankAccount: 'Add Bank Account', //添加银行账户
    BindingType: 'Binding Type', //绑定类型
    BankAccountName: 'Bank Account Name', //银行账户名称
    BankDeposit: 'Bank of Account', //开户银行
    PassbookAccount: 'Passbook Account Number', //存折账号
    PassbookPhoto: 'Passbook Photo', //存折照片

    // 1-2
    title: 'Title', //标题
    Normal: 'Normal', //普通
    keyPoint: 'Key Points', //重点
    post: 'Post Position', //发布岗位
    readPeople: 'Readers', //阅读人数
    amountSingleGiftGoldCoins: 'Amount of gold coins given in a single gift', //单次赠送金币金额
    amountSingleGiftAmountGoldCoinsDonatedGoldCoins: 'Amount of gold coins already given', //已赠送金币金额
    amountSingleGiftAmountGoldCoinsDonatedGoldCoins2: 'Amount of gold coins gifted', //赠送金币金额


    skuCodeNum: 'skuCode',
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js